/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root'
import { Route as CanteenDashboardRouteImport } from './app/routes/canteen-dashboard'
import { Route as LoginRouteImport } from './app/routes/_login'
import { Route as DashboardRouteImport } from './app/routes/_dashboard'
import { Route as AuthRouteImport } from './app/routes/_auth'
import { Route as AuthIndexRouteImport } from './app/routes/_auth/index'
import { Route as DashboardDashboardRouteImport } from './app/routes/_dashboard/dashboard'
import { Route as AuthPhotoRulesRouteImport } from './app/routes/_auth/photo-rules'
import { Route as LoginLoginIndexRouteImport } from './app/routes/_login/login/index'
import { Route as AuthUsersIndexRouteImport } from './app/routes/_auth/users/index'
import { Route as AuthReportsIndexRouteImport } from './app/routes/_auth/reports/index'
import { Route as AuthJournalIndexRouteImport } from './app/routes/_auth/journal/index'
import { Route as AuthCanteenIndexRouteImport } from './app/routes/_auth/canteen/index'
import { Route as AuthApplicationsIndexRouteImport } from './app/routes/_auth/applications/index'
import { Route as AuthAdministrationIndexRouteImport } from './app/routes/_auth/administration/index'
import { Route as LoginAuthSetPasswordRouteImport } from './app/routes/_login/auth/set-password'
import { Route as AuthUsersStudentsRouteImport } from './app/routes/_auth/users/students'
import { Route as AuthUsersParentsRouteImport } from './app/routes/_auth/users/parents'
import { Route as AuthUsersEmployeesRouteImport } from './app/routes/_auth/users/employees'
import { Route as AuthUsersCreateRoleRouteImport } from './app/routes/_auth/users/create-role'
import { Route as AuthUsersApkRouteImport } from './app/routes/_auth/users/apk'
import { Route as AuthReportsVouchersRouteImport } from './app/routes/_auth/reports/vouchers'
import { Route as AuthReportsNoMealVouchersRouteImport } from './app/routes/_auth/reports/no-meal-vouchers'
import { Route as AuthReportsDashboardsRouteImport } from './app/routes/_auth/reports/dashboards'
import { Route as AuthReportsAttendanceRouteImport } from './app/routes/_auth/reports/attendance'
import { Route as AuthJournalTabsRouteImport } from './app/routes/_auth/journal/tabs'
import { Route as AuthCanteenUserCommentsRouteImport } from './app/routes/_auth/canteen/user-comments'
import { Route as AuthCanteenMealRestrictionsRouteImport } from './app/routes/_auth/canteen/meal-restrictions'
import { Route as AuthCanteenManualVoucherApprovalRouteImport } from './app/routes/_auth/canteen/manual-voucher-approval'
import { Route as AuthApplicationsManualVoucherApprovalRouteImport } from './app/routes/_auth/applications/manual-voucher-approval'
import { Route as AuthAdministrationSettingsRouteImport } from './app/routes/_auth/administration/settings'
import { Route as AuthAdministrationMonitoringRouteImport } from './app/routes/_auth/administration/monitoring'
import { Route as LoginLoginForgotPasswordIndexRouteImport } from './app/routes/_login/login/forgot-password/index'
import { Route as AuthCanteenMenuSettingsIndexRouteImport } from './app/routes/_auth/canteen/menu-settings/index'
import { Route as AuthCanteenMealRestrictionsIndexRouteImport } from './app/routes/_auth/canteen/meal-restrictions.index'
import { Route as AuthApplicationsManualVoucherApprovalIndexRouteImport } from './app/routes/_auth/applications/manual-voucher-approval/index'
import { Route as AuthApplicationsLimitationsIndexRouteImport } from './app/routes/_auth/applications/limitations/index'
import { Route as AuthAdministrationReferenceBooksIndexRouteImport } from './app/routes/_auth/administration/reference-books/index'
import { Route as LoginLoginForgotPasswordVerifyOtpRouteImport } from './app/routes/_login/login/forgot-password/verify-otp'
import { Route as LoginLoginForgotPasswordSetNewPasswordRouteImport } from './app/routes/_login/login/forgot-password/set-new-password'
import { Route as AuthUsersUpdateRoleRoleIdRouteImport } from './app/routes/_auth/users/update-role.$roleId'
import { Route as AuthUsersStudentsCreateRouteImport } from './app/routes/_auth/users/students.create'
import { Route as AuthUsersStudentsStudentIdRouteImport } from './app/routes/_auth/users/students.$studentId'
import { Route as AuthUsersRoleRoleIdRouteImport } from './app/routes/_auth/users/role.$roleId'
import { Route as AuthUsersParentsCreateRouteImport } from './app/routes/_auth/users/parents.create'
import { Route as AuthUsersParentsParentIdRouteImport } from './app/routes/_auth/users/parents.$parentId'
import { Route as AuthUsersEmployeesCreateRouteImport } from './app/routes/_auth/users/employees.create'
import { Route as AuthUsersEmployeesEmployeeIdRouteImport } from './app/routes/_auth/users/employees.$employeeId'
import { Route as AuthUsersApkRolesRouteImport } from './app/routes/_auth/users/apk.roles'
import { Route as AuthUsersApkListRouteImport } from './app/routes/_auth/users/apk.list'
import { Route as AuthReportsVouchersCreateRouteImport } from './app/routes/_auth/reports/vouchers.create'
import { Route as AuthReportsNoMealVouchersCreateRouteImport } from './app/routes/_auth/reports/no-meal-vouchers.create'
import { Route as AuthReportsAttendanceCreateRouteImport } from './app/routes/_auth/reports/attendance.create'
import { Route as AuthJournalTabsUsersRouteImport } from './app/routes/_auth/journal/tabs.users'
import { Route as AuthJournalTabsAuthRouteImport } from './app/routes/_auth/journal/tabs.auth'
import { Route as AuthCanteenMenuSettingsDishesRouteImport } from './app/routes/_auth/canteen/menu-settings/dishes'
import { Route as AuthCanteenMenuSettingsCatalogMenuRouteImport } from './app/routes/_auth/canteen/menu-settings/catalog-menu'
import { Route as AuthCanteenManualAttendanceAndFoodReceiptListRouteImport } from './app/routes/_auth/canteen/manual-attendance-and-food-receipt.list'
import { Route as AuthApplicationsManualVoucherConfirmationListRouteImport } from './app/routes/_auth/applications/manual-voucher-confirmation/list'
import { Route as AuthApplicationsManualVoucherConfirmationVoucherIdRouteImport } from './app/routes/_auth/applications/manual-voucher-confirmation/$voucherId'
import { Route as AuthApplicationsManualVoucherApprovalManualVoucherIdRouteImport } from './app/routes/_auth/applications/manual-voucher-approval/$manualVoucherId'
import { Route as AuthApplicationsManualRequestsManualRequestsRouteImport } from './app/routes/_auth/applications/manual-requests/manual-requests'
import { Route as AuthAdministrationSettingsCreateRouteImport } from './app/routes/_auth/administration/settings.create'
import { Route as AuthAdministrationSettingsSettingIdRouteImport } from './app/routes/_auth/administration/settings.$settingId'
import { Route as AuthAdministrationReferenceBooksSchoolsRouteImport } from './app/routes/_auth/administration/reference-books/schools'
import { Route as AuthAdministrationReferenceBooksCompanyRouteImport } from './app/routes/_auth/administration/reference-books/company'
import { Route as AuthAdministrationReferenceBooksCanteensRouteImport } from './app/routes/_auth/administration/reference-books/canteens'
import { Route as AuthAdministrationReferenceBooksCamerasRouteImport } from './app/routes/_auth/administration/reference-books/cameras'
import { Route as AuthAdministrationMonitoringQueueRouteImport } from './app/routes/_auth/administration/monitoring.queue'
import { Route as AuthAdministrationMonitoringProcessesRouteImport } from './app/routes/_auth/administration/monitoring.processes'
import { Route as AuthCanteenMenuSettingsCatalogMenuIndexRouteImport } from './app/routes/_auth/canteen/menu-settings/catalog-menu.index'
import { Route as AuthUsersStudentsUpdateStudentIdRouteImport } from './app/routes/_auth/users/students.update.$studentId'
import { Route as AuthUsersParentsUpdateParentIdRouteImport } from './app/routes/_auth/users/parents.update.$parentId'
import { Route as AuthUsersEmployeesUpdateEmployeeIdRouteImport } from './app/routes/_auth/users/employees.update.$employeeId'
import { Route as AuthUsersApkRolesRoleIdRouteImport } from './app/routes/_auth/users/apk.roles.$roleId'
import { Route as AuthUsersApkListCreateRouteImport } from './app/routes/_auth/users/apk.list.create'
import { Route as AuthUsersApkListUserIdRouteImport } from './app/routes/_auth/users/apk.list.$userId'
import { Route as AuthReportsVouchersItemReportIdRouteImport } from './app/routes/_auth/reports/vouchers_.item.$reportId'
import { Route as AuthReportsNoMealVouchersItemReportIdRouteImport } from './app/routes/_auth/reports/no-meal-vouchers_.item.$reportId'
import { Route as AuthReportsAttendanceItemReportIdRouteImport } from './app/routes/_auth/reports/attendance_.item.$reportId'
import { Route as AuthCanteenUserCommentsStudentStudentIdRouteImport } from './app/routes/_auth/canteen/user-comments.student.$studentId'
import { Route as AuthCanteenUserCommentsDishDishIdRouteImport } from './app/routes/_auth/canteen/user-comments.dish.$dishId'
import { Route as AuthCanteenUserCommentsCommentCommentIdRouteImport } from './app/routes/_auth/canteen/user-comments.comment.$commentId'
import { Route as AuthCanteenMenuSettingsDishesCreateRouteImport } from './app/routes/_auth/canteen/menu-settings/dishes.create'
import { Route as AuthCanteenMenuSettingsDishesDishIdRouteImport } from './app/routes/_auth/canteen/menu-settings/dishes.$dishId'
import { Route as AuthCanteenMenuSettingsCatalogMenuCreateRouteImport } from './app/routes/_auth/canteen/menu-settings/catalog-menu.create'
import { Route as AuthCanteenMealRestrictionsRestrictionRestrictionIdRouteImport } from './app/routes/_auth/canteen/meal-restrictions.restriction.$restrictionId'
import { Route as AuthCanteenManualAttendanceAndFoodReceiptItemCreateRouteImport } from './app/routes/_auth/canteen/manual-attendance-and-food-receipt.item.create'
import { Route as AuthCanteenManualAttendanceAndFoodReceiptItemManualIdRouteImport } from './app/routes/_auth/canteen/manual-attendance-and-food-receipt.item.$manualId'
import { Route as AuthApplicationsManualVoucherApprovalManualVoucherIdItemsRouteImport } from './app/routes/_auth/applications/manual-voucher-approval/$manualVoucherId.items'
import { Route as AuthApplicationsManualVoucherApprovalManualVoucherIdHistoryRouteImport } from './app/routes/_auth/applications/manual-voucher-approval/$manualVoucherId.history'
import { Route as AuthApplicationsManualVoucherApprovalManualVoucherIdCommonRouteImport } from './app/routes/_auth/applications/manual-voucher-approval/$manualVoucherId.common'
import { Route as AuthApplicationsManualRequestsManualRequestsCreateRouteImport } from './app/routes/_auth/applications/manual-requests/manual-requests.create'
import { Route as AuthApplicationsManualRequestsManualRequestRequestIdRouteImport } from './app/routes/_auth/applications/manual-requests/manual-request.$requestId'
import { Route as AuthApplicationsLimitationsLimitationLimitationIdRouteImport } from './app/routes/_auth/applications/limitations/limitation.$limitationId'
import { Route as AuthAdministrationSettingsUpdateSettingIdRouteImport } from './app/routes/_auth/administration/settings.update.$settingId'
import { Route as AuthAdministrationReferenceBooksSchoolsCreateRouteImport } from './app/routes/_auth/administration/reference-books/schools.create'
import { Route as AuthAdministrationReferenceBooksSchoolsSchoolIdRouteImport } from './app/routes/_auth/administration/reference-books/schools.$schoolId'
import { Route as AuthAdministrationReferenceBooksCompanyCreateRouteImport } from './app/routes/_auth/administration/reference-books/company.create'
import { Route as AuthAdministrationReferenceBooksCompanyCompanyIdRouteImport } from './app/routes/_auth/administration/reference-books/company.$companyId'
import { Route as AuthAdministrationReferenceBooksCanteensListRouteImport } from './app/routes/_auth/administration/reference-books/canteens.list'
import { Route as AuthAdministrationReferenceBooksCanteensConnectsRouteImport } from './app/routes/_auth/administration/reference-books/canteens.connects'
import { Route as AuthAdministrationReferenceBooksCamerasCreateRouteImport } from './app/routes/_auth/administration/reference-books/cameras.create'
import { Route as AuthAdministrationReferenceBooksCamerasCameraIdRouteImport } from './app/routes/_auth/administration/reference-books/cameras.$cameraId'
import { Route as AuthAdministrationMonitoringQueueProcessIdRouteImport } from './app/routes/_auth/administration/monitoring.queue.$processId'
import { Route as AuthAdministrationMonitoringProcessesProcessIdRouteImport } from './app/routes/_auth/administration/monitoring.processes.$processId'
import { Route as AuthUsersApkRolesCreateIndexRouteImport } from './app/routes/_auth/users/apk.roles.create.index'
import { Route as AuthUsersApkRolesUpdateRoleIdRouteImport } from './app/routes/_auth/users/apk.roles.update.$roleId'
import { Route as AuthUsersApkListUpdateUserIdRouteImport } from './app/routes/_auth/users/apk.list.update.$userId'
import { Route as AuthCanteenMenuSettingsDishesUpdateDishIdRouteImport } from './app/routes/_auth/canteen/menu-settings/dishes.update.$dishId'
import { Route as AuthCanteenMenuSettingsCatalogMenuUpdateMenuIdRouteImport } from './app/routes/_auth/canteen/menu-settings/catalog-menu.update.$menuId'
import { Route as AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRouteImport } from './app/routes/_auth/canteen/menu-settings/catalog-menu.details.$menuCardId'
import { Route as AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRouteImport } from './app/routes/_auth/canteen/meal-restrictions.restriction.$restrictionId.common'
import { Route as AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRouteImport } from './app/routes/_auth/canteen/meal-restrictions.restriction.$restrictionId.allergens'
import { Route as AuthApplicationsManualRequestsManualRequestRequestIdHistoryRouteImport } from './app/routes/_auth/applications/manual-requests/manual-request.$requestId.history'
import { Route as AuthApplicationsManualRequestsManualRequestRequestIdCommonRouteImport } from './app/routes/_auth/applications/manual-requests/manual-request.$requestId.common'
import { Route as AuthApplicationsLimitationsLimitationLimitationIdHistoryRouteImport } from './app/routes/_auth/applications/limitations/limitation.$limitationId.history'
import { Route as AuthApplicationsLimitationsLimitationLimitationIdCommonRouteImport } from './app/routes/_auth/applications/limitations/limitation.$limitationId.common'
import { Route as AuthApplicationsLimitationsLimitationLimitationIdAllergensRouteImport } from './app/routes/_auth/applications/limitations/limitation.$limitationId.allergens'
import { Route as AuthAdministrationReferenceBooksSchoolsUpdateSchoolIdRouteImport } from './app/routes/_auth/administration/reference-books/schools.update.$schoolId'
import { Route as AuthAdministrationReferenceBooksCompanyUpdateCompanyIdRouteImport } from './app/routes/_auth/administration/reference-books/company.update.$companyId'
import { Route as AuthAdministrationReferenceBooksCanteensListCreateRouteImport } from './app/routes/_auth/administration/reference-books/canteens.list.create'
import { Route as AuthAdministrationReferenceBooksCanteensListCanteenIdRouteImport } from './app/routes/_auth/administration/reference-books/canteens.list.$canteenId'
import { Route as AuthAdministrationReferenceBooksCanteensConnectsCreateRouteImport } from './app/routes/_auth/administration/reference-books/canteens.connects.create'
import { Route as AuthAdministrationReferenceBooksCanteensConnectsConnectIdRouteImport } from './app/routes/_auth/administration/reference-books/canteens.connects.$connectId'
import { Route as AuthAdministrationReferenceBooksCamerasUpdateCameraIdRouteImport } from './app/routes/_auth/administration/reference-books/cameras.update.$cameraId'
import { Route as AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdParametersRouteImport } from './app/routes/_auth/canteen/menu-settings/catalog-menu.details.$menuCardId.parameters'
import { Route as AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdCommonRouteImport } from './app/routes/_auth/canteen/menu-settings/catalog-menu.details.$menuCardId.common'
import { Route as AuthAdministrationReferenceBooksCanteensListUpdateCanteenIdRouteImport } from './app/routes/_auth/administration/reference-books/canteens.list.update.$canteenId'
import { Route as AuthAdministrationReferenceBooksCanteensConnectsUpdateConnectIdRouteImport } from './app/routes/_auth/administration/reference-books/canteens.connects.update.$connectId'
import { Route as AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonUserUserIdRouteImport } from './app/routes/_auth/canteen/meal-restrictions.restriction.$restrictionId.common.user.$userId'
import { Route as AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensDishDishIdRouteImport } from './app/routes/_auth/canteen/meal-restrictions.restriction.$restrictionId.allergens.dish.$dishId'
import { Route as AuthApplicationsLimitationsLimitationLimitationIdCommonUserUserIdRouteImport } from './app/routes/_auth/applications/limitations/limitation.$limitationId.common.user.$userId'
import { Route as AuthApplicationsLimitationsLimitationLimitationIdAllergensDishDishIdRouteImport } from './app/routes/_auth/applications/limitations/limitation.$limitationId.allergens.dish.$dishId'

const CanteenDashboardRoute = CanteenDashboardRouteImport.update({
  id: '/canteen-dashboard',
  path: '/canteen-dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/_login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const DashboardDashboardRoute = DashboardDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => DashboardRoute,
} as any)
const AuthPhotoRulesRoute = AuthPhotoRulesRouteImport.update({
  id: '/photo-rules',
  path: '/photo-rules',
  getParentRoute: () => AuthRoute,
} as any)
const LoginLoginIndexRoute = LoginLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => LoginRoute,
} as any)
const AuthUsersIndexRoute = AuthUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsIndexRoute = AuthReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJournalIndexRoute = AuthJournalIndexRouteImport.update({
  id: '/journal/',
  path: '/journal/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCanteenIndexRoute = AuthCanteenIndexRouteImport.update({
  id: '/canteen/',
  path: '/canteen/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthApplicationsIndexRoute = AuthApplicationsIndexRouteImport.update({
  id: '/applications/',
  path: '/applications/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdministrationIndexRoute = AuthAdministrationIndexRouteImport.update({
  id: '/administration/',
  path: '/administration/',
  getParentRoute: () => AuthRoute,
} as any)
const LoginAuthSetPasswordRoute = LoginAuthSetPasswordRouteImport.update({
  id: '/auth/set-password',
  path: '/auth/set-password',
  getParentRoute: () => LoginRoute,
} as any)
const AuthUsersStudentsRoute = AuthUsersStudentsRouteImport.update({
  id: '/users/students',
  path: '/users/students',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersParentsRoute = AuthUsersParentsRouteImport.update({
  id: '/users/parents',
  path: '/users/parents',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersEmployeesRoute = AuthUsersEmployeesRouteImport.update({
  id: '/users/employees',
  path: '/users/employees',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersCreateRoleRoute = AuthUsersCreateRoleRouteImport.update({
  id: '/users/create-role',
  path: '/users/create-role',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersApkRoute = AuthUsersApkRouteImport.update({
  id: '/users/apk',
  path: '/users/apk',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsVouchersRoute = AuthReportsVouchersRouteImport.update({
  id: '/reports/vouchers',
  path: '/reports/vouchers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsNoMealVouchersRoute =
  AuthReportsNoMealVouchersRouteImport.update({
    id: '/reports/no-meal-vouchers',
    path: '/reports/no-meal-vouchers',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsDashboardsRoute = AuthReportsDashboardsRouteImport.update({
  id: '/reports/dashboards',
  path: '/reports/dashboards',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsAttendanceRoute = AuthReportsAttendanceRouteImport.update({
  id: '/reports/attendance',
  path: '/reports/attendance',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJournalTabsRoute = AuthJournalTabsRouteImport.update({
  id: '/journal/tabs',
  path: '/journal/tabs',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCanteenUserCommentsRoute = AuthCanteenUserCommentsRouteImport.update({
  id: '/canteen/user-comments',
  path: '/canteen/user-comments',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCanteenMealRestrictionsRoute =
  AuthCanteenMealRestrictionsRouteImport.update({
    id: '/canteen/meal-restrictions',
    path: '/canteen/meal-restrictions',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthCanteenManualVoucherApprovalRoute =
  AuthCanteenManualVoucherApprovalRouteImport.update({
    id: '/canteen/manual-voucher-approval',
    path: '/canteen/manual-voucher-approval',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthApplicationsManualVoucherApprovalRoute =
  AuthApplicationsManualVoucherApprovalRouteImport.update({
    id: '/applications/manual-voucher-approval',
    path: '/applications/manual-voucher-approval',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationSettingsRoute =
  AuthAdministrationSettingsRouteImport.update({
    id: '/administration/settings',
    path: '/administration/settings',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationMonitoringRoute =
  AuthAdministrationMonitoringRouteImport.update({
    id: '/administration/monitoring',
    path: '/administration/monitoring',
    getParentRoute: () => AuthRoute,
  } as any)
const LoginLoginForgotPasswordIndexRoute =
  LoginLoginForgotPasswordIndexRouteImport.update({
    id: '/login/forgot-password/',
    path: '/login/forgot-password/',
    getParentRoute: () => LoginRoute,
  } as any)
const AuthCanteenMenuSettingsIndexRoute =
  AuthCanteenMenuSettingsIndexRouteImport.update({
    id: '/canteen/menu-settings/',
    path: '/canteen/menu-settings/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthCanteenMealRestrictionsIndexRoute =
  AuthCanteenMealRestrictionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCanteenMealRestrictionsRoute,
  } as any)
const AuthApplicationsManualVoucherApprovalIndexRoute =
  AuthApplicationsManualVoucherApprovalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthApplicationsManualVoucherApprovalRoute,
  } as any)
const AuthApplicationsLimitationsIndexRoute =
  AuthApplicationsLimitationsIndexRouteImport.update({
    id: '/applications/limitations/',
    path: '/applications/limitations/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationReferenceBooksIndexRoute =
  AuthAdministrationReferenceBooksIndexRouteImport.update({
    id: '/administration/reference-books/',
    path: '/administration/reference-books/',
    getParentRoute: () => AuthRoute,
  } as any)
const LoginLoginForgotPasswordVerifyOtpRoute =
  LoginLoginForgotPasswordVerifyOtpRouteImport.update({
    id: '/login/forgot-password/verify-otp',
    path: '/login/forgot-password/verify-otp',
    getParentRoute: () => LoginRoute,
  } as any)
const LoginLoginForgotPasswordSetNewPasswordRoute =
  LoginLoginForgotPasswordSetNewPasswordRouteImport.update({
    id: '/login/forgot-password/set-new-password',
    path: '/login/forgot-password/set-new-password',
    getParentRoute: () => LoginRoute,
  } as any)
const AuthUsersUpdateRoleRoleIdRoute =
  AuthUsersUpdateRoleRoleIdRouteImport.update({
    id: '/users/update-role/$roleId',
    path: '/users/update-role/$roleId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthUsersStudentsCreateRoute = AuthUsersStudentsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthUsersStudentsRoute,
} as any)
const AuthUsersStudentsStudentIdRoute =
  AuthUsersStudentsStudentIdRouteImport.update({
    id: '/$studentId',
    path: '/$studentId',
    getParentRoute: () => AuthUsersStudentsRoute,
  } as any)
const AuthUsersRoleRoleIdRoute = AuthUsersRoleRoleIdRouteImport.update({
  id: '/users/role/$roleId',
  path: '/users/role/$roleId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersParentsCreateRoute = AuthUsersParentsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthUsersParentsRoute,
} as any)
const AuthUsersParentsParentIdRoute =
  AuthUsersParentsParentIdRouteImport.update({
    id: '/$parentId',
    path: '/$parentId',
    getParentRoute: () => AuthUsersParentsRoute,
  } as any)
const AuthUsersEmployeesCreateRoute =
  AuthUsersEmployeesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthUsersEmployeesRoute,
  } as any)
const AuthUsersEmployeesEmployeeIdRoute =
  AuthUsersEmployeesEmployeeIdRouteImport.update({
    id: '/$employeeId',
    path: '/$employeeId',
    getParentRoute: () => AuthUsersEmployeesRoute,
  } as any)
const AuthUsersApkRolesRoute = AuthUsersApkRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthUsersApkRoute,
} as any)
const AuthUsersApkListRoute = AuthUsersApkListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => AuthUsersApkRoute,
} as any)
const AuthReportsVouchersCreateRoute =
  AuthReportsVouchersCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthReportsVouchersRoute,
  } as any)
const AuthReportsNoMealVouchersCreateRoute =
  AuthReportsNoMealVouchersCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthReportsNoMealVouchersRoute,
  } as any)
const AuthReportsAttendanceCreateRoute =
  AuthReportsAttendanceCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthReportsAttendanceRoute,
  } as any)
const AuthJournalTabsUsersRoute = AuthJournalTabsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthJournalTabsRoute,
} as any)
const AuthJournalTabsAuthRoute = AuthJournalTabsAuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => AuthJournalTabsRoute,
} as any)
const AuthCanteenMenuSettingsDishesRoute =
  AuthCanteenMenuSettingsDishesRouteImport.update({
    id: '/canteen/menu-settings/dishes',
    path: '/canteen/menu-settings/dishes',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthCanteenMenuSettingsCatalogMenuRoute =
  AuthCanteenMenuSettingsCatalogMenuRouteImport.update({
    id: '/canteen/menu-settings/catalog-menu',
    path: '/canteen/menu-settings/catalog-menu',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthCanteenManualAttendanceAndFoodReceiptListRoute =
  AuthCanteenManualAttendanceAndFoodReceiptListRouteImport.update({
    id: '/canteen/manual-attendance-and-food-receipt/list',
    path: '/canteen/manual-attendance-and-food-receipt/list',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthApplicationsManualVoucherConfirmationListRoute =
  AuthApplicationsManualVoucherConfirmationListRouteImport.update({
    id: '/applications/manual-voucher-confirmation/list',
    path: '/applications/manual-voucher-confirmation/list',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthApplicationsManualVoucherConfirmationVoucherIdRoute =
  AuthApplicationsManualVoucherConfirmationVoucherIdRouteImport.update({
    id: '/applications/manual-voucher-confirmation/$voucherId',
    path: '/applications/manual-voucher-confirmation/$voucherId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthApplicationsManualVoucherApprovalManualVoucherIdRoute =
  AuthApplicationsManualVoucherApprovalManualVoucherIdRouteImport.update({
    id: '/$manualVoucherId',
    path: '/$manualVoucherId',
    getParentRoute: () => AuthApplicationsManualVoucherApprovalRoute,
  } as any)
const AuthApplicationsManualRequestsManualRequestsRoute =
  AuthApplicationsManualRequestsManualRequestsRouteImport.update({
    id: '/applications/manual-requests/manual-requests',
    path: '/applications/manual-requests/manual-requests',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationSettingsCreateRoute =
  AuthAdministrationSettingsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAdministrationSettingsRoute,
  } as any)
const AuthAdministrationSettingsSettingIdRoute =
  AuthAdministrationSettingsSettingIdRouteImport.update({
    id: '/$settingId',
    path: '/$settingId',
    getParentRoute: () => AuthAdministrationSettingsRoute,
  } as any)
const AuthAdministrationReferenceBooksSchoolsRoute =
  AuthAdministrationReferenceBooksSchoolsRouteImport.update({
    id: '/administration/reference-books/schools',
    path: '/administration/reference-books/schools',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationReferenceBooksCompanyRoute =
  AuthAdministrationReferenceBooksCompanyRouteImport.update({
    id: '/administration/reference-books/company',
    path: '/administration/reference-books/company',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationReferenceBooksCanteensRoute =
  AuthAdministrationReferenceBooksCanteensRouteImport.update({
    id: '/administration/reference-books/canteens',
    path: '/administration/reference-books/canteens',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationReferenceBooksCamerasRoute =
  AuthAdministrationReferenceBooksCamerasRouteImport.update({
    id: '/administration/reference-books/cameras',
    path: '/administration/reference-books/cameras',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationMonitoringQueueRoute =
  AuthAdministrationMonitoringQueueRouteImport.update({
    id: '/queue',
    path: '/queue',
    getParentRoute: () => AuthAdministrationMonitoringRoute,
  } as any)
const AuthAdministrationMonitoringProcessesRoute =
  AuthAdministrationMonitoringProcessesRouteImport.update({
    id: '/processes',
    path: '/processes',
    getParentRoute: () => AuthAdministrationMonitoringRoute,
  } as any)
const AuthCanteenMenuSettingsCatalogMenuIndexRoute =
  AuthCanteenMenuSettingsCatalogMenuIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCanteenMenuSettingsCatalogMenuRoute,
  } as any)
const AuthUsersStudentsUpdateStudentIdRoute =
  AuthUsersStudentsUpdateStudentIdRouteImport.update({
    id: '/update/$studentId',
    path: '/update/$studentId',
    getParentRoute: () => AuthUsersStudentsRoute,
  } as any)
const AuthUsersParentsUpdateParentIdRoute =
  AuthUsersParentsUpdateParentIdRouteImport.update({
    id: '/update/$parentId',
    path: '/update/$parentId',
    getParentRoute: () => AuthUsersParentsRoute,
  } as any)
const AuthUsersEmployeesUpdateEmployeeIdRoute =
  AuthUsersEmployeesUpdateEmployeeIdRouteImport.update({
    id: '/update/$employeeId',
    path: '/update/$employeeId',
    getParentRoute: () => AuthUsersEmployeesRoute,
  } as any)
const AuthUsersApkRolesRoleIdRoute = AuthUsersApkRolesRoleIdRouteImport.update({
  id: '/$roleId',
  path: '/$roleId',
  getParentRoute: () => AuthUsersApkRolesRoute,
} as any)
const AuthUsersApkListCreateRoute = AuthUsersApkListCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthUsersApkListRoute,
} as any)
const AuthUsersApkListUserIdRoute = AuthUsersApkListUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AuthUsersApkListRoute,
} as any)
const AuthReportsVouchersItemReportIdRoute =
  AuthReportsVouchersItemReportIdRouteImport.update({
    id: '/reports/vouchers_/item/$reportId',
    path: '/reports/vouchers/item/$reportId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsNoMealVouchersItemReportIdRoute =
  AuthReportsNoMealVouchersItemReportIdRouteImport.update({
    id: '/reports/no-meal-vouchers_/item/$reportId',
    path: '/reports/no-meal-vouchers/item/$reportId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsAttendanceItemReportIdRoute =
  AuthReportsAttendanceItemReportIdRouteImport.update({
    id: '/reports/attendance_/item/$reportId',
    path: '/reports/attendance/item/$reportId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthCanteenUserCommentsStudentStudentIdRoute =
  AuthCanteenUserCommentsStudentStudentIdRouteImport.update({
    id: '/student/$studentId',
    path: '/student/$studentId',
    getParentRoute: () => AuthCanteenUserCommentsRoute,
  } as any)
const AuthCanteenUserCommentsDishDishIdRoute =
  AuthCanteenUserCommentsDishDishIdRouteImport.update({
    id: '/dish/$dishId',
    path: '/dish/$dishId',
    getParentRoute: () => AuthCanteenUserCommentsRoute,
  } as any)
const AuthCanteenUserCommentsCommentCommentIdRoute =
  AuthCanteenUserCommentsCommentCommentIdRouteImport.update({
    id: '/comment/$commentId',
    path: '/comment/$commentId',
    getParentRoute: () => AuthCanteenUserCommentsRoute,
  } as any)
const AuthCanteenMenuSettingsDishesCreateRoute =
  AuthCanteenMenuSettingsDishesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthCanteenMenuSettingsDishesRoute,
  } as any)
const AuthCanteenMenuSettingsDishesDishIdRoute =
  AuthCanteenMenuSettingsDishesDishIdRouteImport.update({
    id: '/$dishId',
    path: '/$dishId',
    getParentRoute: () => AuthCanteenMenuSettingsDishesRoute,
  } as any)
const AuthCanteenMenuSettingsCatalogMenuCreateRoute =
  AuthCanteenMenuSettingsCatalogMenuCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthCanteenMenuSettingsCatalogMenuRoute,
  } as any)
const AuthCanteenMealRestrictionsRestrictionRestrictionIdRoute =
  AuthCanteenMealRestrictionsRestrictionRestrictionIdRouteImport.update({
    id: '/restriction/$restrictionId',
    path: '/restriction/$restrictionId',
    getParentRoute: () => AuthCanteenMealRestrictionsRoute,
  } as any)
const AuthCanteenManualAttendanceAndFoodReceiptItemCreateRoute =
  AuthCanteenManualAttendanceAndFoodReceiptItemCreateRouteImport.update({
    id: '/canteen/manual-attendance-and-food-receipt/item/create',
    path: '/canteen/manual-attendance-and-food-receipt/item/create',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthCanteenManualAttendanceAndFoodReceiptItemManualIdRoute =
  AuthCanteenManualAttendanceAndFoodReceiptItemManualIdRouteImport.update({
    id: '/canteen/manual-attendance-and-food-receipt/item/$manualId',
    path: '/canteen/manual-attendance-and-food-receipt/item/$manualId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthApplicationsManualVoucherApprovalManualVoucherIdItemsRoute =
  AuthApplicationsManualVoucherApprovalManualVoucherIdItemsRouteImport.update({
    id: '/items',
    path: '/items',
    getParentRoute: () =>
      AuthApplicationsManualVoucherApprovalManualVoucherIdRoute,
  } as any)
const AuthApplicationsManualVoucherApprovalManualVoucherIdHistoryRoute =
  AuthApplicationsManualVoucherApprovalManualVoucherIdHistoryRouteImport.update(
    {
      id: '/history',
      path: '/history',
      getParentRoute: () =>
        AuthApplicationsManualVoucherApprovalManualVoucherIdRoute,
    } as any,
  )
const AuthApplicationsManualVoucherApprovalManualVoucherIdCommonRoute =
  AuthApplicationsManualVoucherApprovalManualVoucherIdCommonRouteImport.update({
    id: '/common',
    path: '/common',
    getParentRoute: () =>
      AuthApplicationsManualVoucherApprovalManualVoucherIdRoute,
  } as any)
const AuthApplicationsManualRequestsManualRequestsCreateRoute =
  AuthApplicationsManualRequestsManualRequestsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthApplicationsManualRequestsManualRequestsRoute,
  } as any)
const AuthApplicationsManualRequestsManualRequestRequestIdRoute =
  AuthApplicationsManualRequestsManualRequestRequestIdRouteImport.update({
    id: '/applications/manual-requests/manual-request/$requestId',
    path: '/applications/manual-requests/manual-request/$requestId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthApplicationsLimitationsLimitationLimitationIdRoute =
  AuthApplicationsLimitationsLimitationLimitationIdRouteImport.update({
    id: '/applications/limitations/limitation/$limitationId',
    path: '/applications/limitations/limitation/$limitationId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationSettingsUpdateSettingIdRoute =
  AuthAdministrationSettingsUpdateSettingIdRouteImport.update({
    id: '/update/$settingId',
    path: '/update/$settingId',
    getParentRoute: () => AuthAdministrationSettingsRoute,
  } as any)
const AuthAdministrationReferenceBooksSchoolsCreateRoute =
  AuthAdministrationReferenceBooksSchoolsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAdministrationReferenceBooksSchoolsRoute,
  } as any)
const AuthAdministrationReferenceBooksSchoolsSchoolIdRoute =
  AuthAdministrationReferenceBooksSchoolsSchoolIdRouteImport.update({
    id: '/$schoolId',
    path: '/$schoolId',
    getParentRoute: () => AuthAdministrationReferenceBooksSchoolsRoute,
  } as any)
const AuthAdministrationReferenceBooksCompanyCreateRoute =
  AuthAdministrationReferenceBooksCompanyCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAdministrationReferenceBooksCompanyRoute,
  } as any)
const AuthAdministrationReferenceBooksCompanyCompanyIdRoute =
  AuthAdministrationReferenceBooksCompanyCompanyIdRouteImport.update({
    id: '/$companyId',
    path: '/$companyId',
    getParentRoute: () => AuthAdministrationReferenceBooksCompanyRoute,
  } as any)
const AuthAdministrationReferenceBooksCanteensListRoute =
  AuthAdministrationReferenceBooksCanteensListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => AuthAdministrationReferenceBooksCanteensRoute,
  } as any)
const AuthAdministrationReferenceBooksCanteensConnectsRoute =
  AuthAdministrationReferenceBooksCanteensConnectsRouteImport.update({
    id: '/connects',
    path: '/connects',
    getParentRoute: () => AuthAdministrationReferenceBooksCanteensRoute,
  } as any)
const AuthAdministrationReferenceBooksCamerasCreateRoute =
  AuthAdministrationReferenceBooksCamerasCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAdministrationReferenceBooksCamerasRoute,
  } as any)
const AuthAdministrationReferenceBooksCamerasCameraIdRoute =
  AuthAdministrationReferenceBooksCamerasCameraIdRouteImport.update({
    id: '/$cameraId',
    path: '/$cameraId',
    getParentRoute: () => AuthAdministrationReferenceBooksCamerasRoute,
  } as any)
const AuthAdministrationMonitoringQueueProcessIdRoute =
  AuthAdministrationMonitoringQueueProcessIdRouteImport.update({
    id: '/$processId',
    path: '/$processId',
    getParentRoute: () => AuthAdministrationMonitoringQueueRoute,
  } as any)
const AuthAdministrationMonitoringProcessesProcessIdRoute =
  AuthAdministrationMonitoringProcessesProcessIdRouteImport.update({
    id: '/$processId',
    path: '/$processId',
    getParentRoute: () => AuthAdministrationMonitoringProcessesRoute,
  } as any)
const AuthUsersApkRolesCreateIndexRoute =
  AuthUsersApkRolesCreateIndexRouteImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => AuthUsersApkRolesRoute,
  } as any)
const AuthUsersApkRolesUpdateRoleIdRoute =
  AuthUsersApkRolesUpdateRoleIdRouteImport.update({
    id: '/update/$roleId',
    path: '/update/$roleId',
    getParentRoute: () => AuthUsersApkRolesRoute,
  } as any)
const AuthUsersApkListUpdateUserIdRoute =
  AuthUsersApkListUpdateUserIdRouteImport.update({
    id: '/update/$userId',
    path: '/update/$userId',
    getParentRoute: () => AuthUsersApkListRoute,
  } as any)
const AuthCanteenMenuSettingsDishesUpdateDishIdRoute =
  AuthCanteenMenuSettingsDishesUpdateDishIdRouteImport.update({
    id: '/update/$dishId',
    path: '/update/$dishId',
    getParentRoute: () => AuthCanteenMenuSettingsDishesRoute,
  } as any)
const AuthCanteenMenuSettingsCatalogMenuUpdateMenuIdRoute =
  AuthCanteenMenuSettingsCatalogMenuUpdateMenuIdRouteImport.update({
    id: '/update/$menuId',
    path: '/update/$menuId',
    getParentRoute: () => AuthCanteenMenuSettingsCatalogMenuRoute,
  } as any)
const AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRoute =
  AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRouteImport.update({
    id: '/details/$menuCardId',
    path: '/details/$menuCardId',
    getParentRoute: () => AuthCanteenMenuSettingsCatalogMenuRoute,
  } as any)
const AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRoute =
  AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRouteImport.update({
    id: '/common',
    path: '/common',
    getParentRoute: () =>
      AuthCanteenMealRestrictionsRestrictionRestrictionIdRoute,
  } as any)
const AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRoute =
  AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRouteImport.update(
    {
      id: '/allergens',
      path: '/allergens',
      getParentRoute: () =>
        AuthCanteenMealRestrictionsRestrictionRestrictionIdRoute,
    } as any,
  )
const AuthApplicationsManualRequestsManualRequestRequestIdHistoryRoute =
  AuthApplicationsManualRequestsManualRequestRequestIdHistoryRouteImport.update(
    {
      id: '/history',
      path: '/history',
      getParentRoute: () =>
        AuthApplicationsManualRequestsManualRequestRequestIdRoute,
    } as any,
  )
const AuthApplicationsManualRequestsManualRequestRequestIdCommonRoute =
  AuthApplicationsManualRequestsManualRequestRequestIdCommonRouteImport.update({
    id: '/common',
    path: '/common',
    getParentRoute: () =>
      AuthApplicationsManualRequestsManualRequestRequestIdRoute,
  } as any)
const AuthApplicationsLimitationsLimitationLimitationIdHistoryRoute =
  AuthApplicationsLimitationsLimitationLimitationIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () =>
      AuthApplicationsLimitationsLimitationLimitationIdRoute,
  } as any)
const AuthApplicationsLimitationsLimitationLimitationIdCommonRoute =
  AuthApplicationsLimitationsLimitationLimitationIdCommonRouteImport.update({
    id: '/common',
    path: '/common',
    getParentRoute: () =>
      AuthApplicationsLimitationsLimitationLimitationIdRoute,
  } as any)
const AuthApplicationsLimitationsLimitationLimitationIdAllergensRoute =
  AuthApplicationsLimitationsLimitationLimitationIdAllergensRouteImport.update({
    id: '/allergens',
    path: '/allergens',
    getParentRoute: () =>
      AuthApplicationsLimitationsLimitationLimitationIdRoute,
  } as any)
const AuthAdministrationReferenceBooksSchoolsUpdateSchoolIdRoute =
  AuthAdministrationReferenceBooksSchoolsUpdateSchoolIdRouteImport.update({
    id: '/update/$schoolId',
    path: '/update/$schoolId',
    getParentRoute: () => AuthAdministrationReferenceBooksSchoolsRoute,
  } as any)
const AuthAdministrationReferenceBooksCompanyUpdateCompanyIdRoute =
  AuthAdministrationReferenceBooksCompanyUpdateCompanyIdRouteImport.update({
    id: '/update/$companyId',
    path: '/update/$companyId',
    getParentRoute: () => AuthAdministrationReferenceBooksCompanyRoute,
  } as any)
const AuthAdministrationReferenceBooksCanteensListCreateRoute =
  AuthAdministrationReferenceBooksCanteensListCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAdministrationReferenceBooksCanteensListRoute,
  } as any)
const AuthAdministrationReferenceBooksCanteensListCanteenIdRoute =
  AuthAdministrationReferenceBooksCanteensListCanteenIdRouteImport.update({
    id: '/$canteenId',
    path: '/$canteenId',
    getParentRoute: () => AuthAdministrationReferenceBooksCanteensListRoute,
  } as any)
const AuthAdministrationReferenceBooksCanteensConnectsCreateRoute =
  AuthAdministrationReferenceBooksCanteensConnectsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAdministrationReferenceBooksCanteensConnectsRoute,
  } as any)
const AuthAdministrationReferenceBooksCanteensConnectsConnectIdRoute =
  AuthAdministrationReferenceBooksCanteensConnectsConnectIdRouteImport.update({
    id: '/$connectId',
    path: '/$connectId',
    getParentRoute: () => AuthAdministrationReferenceBooksCanteensConnectsRoute,
  } as any)
const AuthAdministrationReferenceBooksCamerasUpdateCameraIdRoute =
  AuthAdministrationReferenceBooksCamerasUpdateCameraIdRouteImport.update({
    id: '/update/$cameraId',
    path: '/update/$cameraId',
    getParentRoute: () => AuthAdministrationReferenceBooksCamerasRoute,
  } as any)
const AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdParametersRoute =
  AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdParametersRouteImport.update(
    {
      id: '/parameters',
      path: '/parameters',
      getParentRoute: () =>
        AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRoute,
    } as any,
  )
const AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdCommonRoute =
  AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdCommonRouteImport.update({
    id: '/common',
    path: '/common',
    getParentRoute: () =>
      AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRoute,
  } as any)
const AuthAdministrationReferenceBooksCanteensListUpdateCanteenIdRoute =
  AuthAdministrationReferenceBooksCanteensListUpdateCanteenIdRouteImport.update(
    {
      id: '/update/$canteenId',
      path: '/update/$canteenId',
      getParentRoute: () => AuthAdministrationReferenceBooksCanteensListRoute,
    } as any,
  )
const AuthAdministrationReferenceBooksCanteensConnectsUpdateConnectIdRoute =
  AuthAdministrationReferenceBooksCanteensConnectsUpdateConnectIdRouteImport.update(
    {
      id: '/update/$connectId',
      path: '/update/$connectId',
      getParentRoute: () =>
        AuthAdministrationReferenceBooksCanteensConnectsRoute,
    } as any,
  )
const AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonUserUserIdRoute =
  AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonUserUserIdRouteImport.update(
    {
      id: '/user/$userId',
      path: '/user/$userId',
      getParentRoute: () =>
        AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRoute,
    } as any,
  )
const AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensDishDishIdRoute =
  AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensDishDishIdRouteImport.update(
    {
      id: '/dish/$dishId',
      path: '/dish/$dishId',
      getParentRoute: () =>
        AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRoute,
    } as any,
  )
const AuthApplicationsLimitationsLimitationLimitationIdCommonUserUserIdRoute =
  AuthApplicationsLimitationsLimitationLimitationIdCommonUserUserIdRouteImport.update(
    {
      id: '/user/$userId',
      path: '/user/$userId',
      getParentRoute: () =>
        AuthApplicationsLimitationsLimitationLimitationIdCommonRoute,
    } as any,
  )
const AuthApplicationsLimitationsLimitationLimitationIdAllergensDishDishIdRoute =
  AuthApplicationsLimitationsLimitationLimitationIdAllergensDishDishIdRouteImport.update(
    {
      id: '/dish/$dishId',
      path: '/dish/$dishId',
      getParentRoute: () =>
        AuthApplicationsLimitationsLimitationLimitationIdAllergensRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/canteen-dashboard': typeof CanteenDashboardRoute
  '/photo-rules': typeof AuthPhotoRulesRoute
  '/dashboard': typeof DashboardDashboardRoute
  '/administration/monitoring': typeof AuthAdministrationMonitoringRouteWithChildren
  '/administration/settings': typeof AuthAdministrationSettingsRouteWithChildren
  '/applications/manual-voucher-approval': typeof AuthApplicationsManualVoucherApprovalRouteWithChildren
  '/canteen/manual-voucher-approval': typeof AuthCanteenManualVoucherApprovalRoute
  '/canteen/meal-restrictions': typeof AuthCanteenMealRestrictionsRouteWithChildren
  '/canteen/user-comments': typeof AuthCanteenUserCommentsRouteWithChildren
  '/journal/tabs': typeof AuthJournalTabsRouteWithChildren
  '/reports/attendance': typeof AuthReportsAttendanceRouteWithChildren
  '/reports/dashboards': typeof AuthReportsDashboardsRoute
  '/reports/no-meal-vouchers': typeof AuthReportsNoMealVouchersRouteWithChildren
  '/reports/vouchers': typeof AuthReportsVouchersRouteWithChildren
  '/users/apk': typeof AuthUsersApkRouteWithChildren
  '/users/create-role': typeof AuthUsersCreateRoleRoute
  '/users/employees': typeof AuthUsersEmployeesRouteWithChildren
  '/users/parents': typeof AuthUsersParentsRouteWithChildren
  '/users/students': typeof AuthUsersStudentsRouteWithChildren
  '/auth/set-password': typeof LoginAuthSetPasswordRoute
  '/administration/': typeof AuthAdministrationIndexRoute
  '/applications/': typeof AuthApplicationsIndexRoute
  '/canteen/': typeof AuthCanteenIndexRoute
  '/journal/': typeof AuthJournalIndexRoute
  '/reports/': typeof AuthReportsIndexRoute
  '/users/': typeof AuthUsersIndexRoute
  '/login/': typeof LoginLoginIndexRoute
  '/administration/monitoring/processes': typeof AuthAdministrationMonitoringProcessesRouteWithChildren
  '/administration/monitoring/queue': typeof AuthAdministrationMonitoringQueueRouteWithChildren
  '/administration/reference-books/cameras': typeof AuthAdministrationReferenceBooksCamerasRouteWithChildren
  '/administration/reference-books/canteens': typeof AuthAdministrationReferenceBooksCanteensRouteWithChildren
  '/administration/reference-books/company': typeof AuthAdministrationReferenceBooksCompanyRouteWithChildren
  '/administration/reference-books/schools': typeof AuthAdministrationReferenceBooksSchoolsRouteWithChildren
  '/administration/settings/$settingId': typeof AuthAdministrationSettingsSettingIdRoute
  '/administration/settings/create': typeof AuthAdministrationSettingsCreateRoute
  '/applications/manual-requests/manual-requests': typeof AuthApplicationsManualRequestsManualRequestsRouteWithChildren
  '/applications/manual-voucher-approval/$manualVoucherId': typeof AuthApplicationsManualVoucherApprovalManualVoucherIdRouteWithChildren
  '/applications/manual-voucher-confirmation/$voucherId': typeof AuthApplicationsManualVoucherConfirmationVoucherIdRoute
  '/applications/manual-voucher-confirmation/list': typeof AuthApplicationsManualVoucherConfirmationListRoute
  '/canteen/manual-attendance-and-food-receipt/list': typeof AuthCanteenManualAttendanceAndFoodReceiptListRoute
  '/canteen/menu-settings/catalog-menu': typeof AuthCanteenMenuSettingsCatalogMenuRouteWithChildren
  '/canteen/menu-settings/dishes': typeof AuthCanteenMenuSettingsDishesRouteWithChildren
  '/journal/tabs/auth': typeof AuthJournalTabsAuthRoute
  '/journal/tabs/users': typeof AuthJournalTabsUsersRoute
  '/reports/attendance/create': typeof AuthReportsAttendanceCreateRoute
  '/reports/no-meal-vouchers/create': typeof AuthReportsNoMealVouchersCreateRoute
  '/reports/vouchers/create': typeof AuthReportsVouchersCreateRoute
  '/users/apk/list': typeof AuthUsersApkListRouteWithChildren
  '/users/apk/roles': typeof AuthUsersApkRolesRouteWithChildren
  '/users/employees/$employeeId': typeof AuthUsersEmployeesEmployeeIdRoute
  '/users/employees/create': typeof AuthUsersEmployeesCreateRoute
  '/users/parents/$parentId': typeof AuthUsersParentsParentIdRoute
  '/users/parents/create': typeof AuthUsersParentsCreateRoute
  '/users/role/$roleId': typeof AuthUsersRoleRoleIdRoute
  '/users/students/$studentId': typeof AuthUsersStudentsStudentIdRoute
  '/users/students/create': typeof AuthUsersStudentsCreateRoute
  '/users/update-role/$roleId': typeof AuthUsersUpdateRoleRoleIdRoute
  '/login/forgot-password/set-new-password': typeof LoginLoginForgotPasswordSetNewPasswordRoute
  '/login/forgot-password/verify-otp': typeof LoginLoginForgotPasswordVerifyOtpRoute
  '/administration/reference-books/': typeof AuthAdministrationReferenceBooksIndexRoute
  '/applications/limitations/': typeof AuthApplicationsLimitationsIndexRoute
  '/applications/manual-voucher-approval/': typeof AuthApplicationsManualVoucherApprovalIndexRoute
  '/canteen/meal-restrictions/': typeof AuthCanteenMealRestrictionsIndexRoute
  '/canteen/menu-settings/': typeof AuthCanteenMenuSettingsIndexRoute
  '/login/forgot-password/': typeof LoginLoginForgotPasswordIndexRoute
  '/administration/monitoring/processes/$processId': typeof AuthAdministrationMonitoringProcessesProcessIdRoute
  '/administration/monitoring/queue/$processId': typeof AuthAdministrationMonitoringQueueProcessIdRoute
  '/administration/reference-books/cameras/$cameraId': typeof AuthAdministrationReferenceBooksCamerasCameraIdRoute
  '/administration/reference-books/cameras/create': typeof AuthAdministrationReferenceBooksCamerasCreateRoute
  '/administration/reference-books/canteens/connects': typeof AuthAdministrationReferenceBooksCanteensConnectsRouteWithChildren
  '/administration/reference-books/canteens/list': typeof AuthAdministrationReferenceBooksCanteensListRouteWithChildren
  '/administration/reference-books/company/$companyId': typeof AuthAdministrationReferenceBooksCompanyCompanyIdRoute
  '/administration/reference-books/company/create': typeof AuthAdministrationReferenceBooksCompanyCreateRoute
  '/administration/reference-books/schools/$schoolId': typeof AuthAdministrationReferenceBooksSchoolsSchoolIdRoute
  '/administration/reference-books/schools/create': typeof AuthAdministrationReferenceBooksSchoolsCreateRoute
  '/administration/settings/update/$settingId': typeof AuthAdministrationSettingsUpdateSettingIdRoute
  '/applications/limitations/limitation/$limitationId': typeof AuthApplicationsLimitationsLimitationLimitationIdRouteWithChildren
  '/applications/manual-requests/manual-request/$requestId': typeof AuthApplicationsManualRequestsManualRequestRequestIdRouteWithChildren
  '/applications/manual-requests/manual-requests/create': typeof AuthApplicationsManualRequestsManualRequestsCreateRoute
  '/applications/manual-voucher-approval/$manualVoucherId/common': typeof AuthApplicationsManualVoucherApprovalManualVoucherIdCommonRoute
  '/applications/manual-voucher-approval/$manualVoucherId/history': typeof AuthApplicationsManualVoucherApprovalManualVoucherIdHistoryRoute
  '/applications/manual-voucher-approval/$manualVoucherId/items': typeof AuthApplicationsManualVoucherApprovalManualVoucherIdItemsRoute
  '/canteen/manual-attendance-and-food-receipt/item/$manualId': typeof AuthCanteenManualAttendanceAndFoodReceiptItemManualIdRoute
  '/canteen/manual-attendance-and-food-receipt/item/create': typeof AuthCanteenManualAttendanceAndFoodReceiptItemCreateRoute
  '/canteen/meal-restrictions/restriction/$restrictionId': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdRouteWithChildren
  '/canteen/menu-settings/catalog-menu/create': typeof AuthCanteenMenuSettingsCatalogMenuCreateRoute
  '/canteen/menu-settings/dishes/$dishId': typeof AuthCanteenMenuSettingsDishesDishIdRoute
  '/canteen/menu-settings/dishes/create': typeof AuthCanteenMenuSettingsDishesCreateRoute
  '/canteen/user-comments/comment/$commentId': typeof AuthCanteenUserCommentsCommentCommentIdRoute
  '/canteen/user-comments/dish/$dishId': typeof AuthCanteenUserCommentsDishDishIdRoute
  '/canteen/user-comments/student/$studentId': typeof AuthCanteenUserCommentsStudentStudentIdRoute
  '/reports/attendance/item/$reportId': typeof AuthReportsAttendanceItemReportIdRoute
  '/reports/no-meal-vouchers/item/$reportId': typeof AuthReportsNoMealVouchersItemReportIdRoute
  '/reports/vouchers/item/$reportId': typeof AuthReportsVouchersItemReportIdRoute
  '/users/apk/list/$userId': typeof AuthUsersApkListUserIdRoute
  '/users/apk/list/create': typeof AuthUsersApkListCreateRoute
  '/users/apk/roles/$roleId': typeof AuthUsersApkRolesRoleIdRoute
  '/users/employees/update/$employeeId': typeof AuthUsersEmployeesUpdateEmployeeIdRoute
  '/users/parents/update/$parentId': typeof AuthUsersParentsUpdateParentIdRoute
  '/users/students/update/$studentId': typeof AuthUsersStudentsUpdateStudentIdRoute
  '/canteen/menu-settings/catalog-menu/': typeof AuthCanteenMenuSettingsCatalogMenuIndexRoute
  '/administration/reference-books/cameras/update/$cameraId': typeof AuthAdministrationReferenceBooksCamerasUpdateCameraIdRoute
  '/administration/reference-books/canteens/connects/$connectId': typeof AuthAdministrationReferenceBooksCanteensConnectsConnectIdRoute
  '/administration/reference-books/canteens/connects/create': typeof AuthAdministrationReferenceBooksCanteensConnectsCreateRoute
  '/administration/reference-books/canteens/list/$canteenId': typeof AuthAdministrationReferenceBooksCanteensListCanteenIdRoute
  '/administration/reference-books/canteens/list/create': typeof AuthAdministrationReferenceBooksCanteensListCreateRoute
  '/administration/reference-books/company/update/$companyId': typeof AuthAdministrationReferenceBooksCompanyUpdateCompanyIdRoute
  '/administration/reference-books/schools/update/$schoolId': typeof AuthAdministrationReferenceBooksSchoolsUpdateSchoolIdRoute
  '/applications/limitations/limitation/$limitationId/allergens': typeof AuthApplicationsLimitationsLimitationLimitationIdAllergensRouteWithChildren
  '/applications/limitations/limitation/$limitationId/common': typeof AuthApplicationsLimitationsLimitationLimitationIdCommonRouteWithChildren
  '/applications/limitations/limitation/$limitationId/history': typeof AuthApplicationsLimitationsLimitationLimitationIdHistoryRoute
  '/applications/manual-requests/manual-request/$requestId/common': typeof AuthApplicationsManualRequestsManualRequestRequestIdCommonRoute
  '/applications/manual-requests/manual-request/$requestId/history': typeof AuthApplicationsManualRequestsManualRequestRequestIdHistoryRoute
  '/canteen/meal-restrictions/restriction/$restrictionId/allergens': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRouteWithChildren
  '/canteen/meal-restrictions/restriction/$restrictionId/common': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRouteWithChildren
  '/canteen/menu-settings/catalog-menu/details/$menuCardId': typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRouteWithChildren
  '/canteen/menu-settings/catalog-menu/update/$menuId': typeof AuthCanteenMenuSettingsCatalogMenuUpdateMenuIdRoute
  '/canteen/menu-settings/dishes/update/$dishId': typeof AuthCanteenMenuSettingsDishesUpdateDishIdRoute
  '/users/apk/list/update/$userId': typeof AuthUsersApkListUpdateUserIdRoute
  '/users/apk/roles/update/$roleId': typeof AuthUsersApkRolesUpdateRoleIdRoute
  '/users/apk/roles/create/': typeof AuthUsersApkRolesCreateIndexRoute
  '/administration/reference-books/canteens/connects/update/$connectId': typeof AuthAdministrationReferenceBooksCanteensConnectsUpdateConnectIdRoute
  '/administration/reference-books/canteens/list/update/$canteenId': typeof AuthAdministrationReferenceBooksCanteensListUpdateCanteenIdRoute
  '/canteen/menu-settings/catalog-menu/details/$menuCardId/common': typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdCommonRoute
  '/canteen/menu-settings/catalog-menu/details/$menuCardId/parameters': typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdParametersRoute
  '/applications/limitations/limitation/$limitationId/allergens/dish/$dishId': typeof AuthApplicationsLimitationsLimitationLimitationIdAllergensDishDishIdRoute
  '/applications/limitations/limitation/$limitationId/common/user/$userId': typeof AuthApplicationsLimitationsLimitationLimitationIdCommonUserUserIdRoute
  '/canteen/meal-restrictions/restriction/$restrictionId/allergens/dish/$dishId': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensDishDishIdRoute
  '/canteen/meal-restrictions/restriction/$restrictionId/common/user/$userId': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonUserUserIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthIndexRoute
  '/canteen-dashboard': typeof CanteenDashboardRoute
  '/photo-rules': typeof AuthPhotoRulesRoute
  '/dashboard': typeof DashboardDashboardRoute
  '/administration/monitoring': typeof AuthAdministrationMonitoringRouteWithChildren
  '/administration/settings': typeof AuthAdministrationSettingsRouteWithChildren
  '/canteen/manual-voucher-approval': typeof AuthCanteenManualVoucherApprovalRoute
  '/canteen/user-comments': typeof AuthCanteenUserCommentsRouteWithChildren
  '/journal/tabs': typeof AuthJournalTabsRouteWithChildren
  '/reports/attendance': typeof AuthReportsAttendanceRouteWithChildren
  '/reports/dashboards': typeof AuthReportsDashboardsRoute
  '/reports/no-meal-vouchers': typeof AuthReportsNoMealVouchersRouteWithChildren
  '/reports/vouchers': typeof AuthReportsVouchersRouteWithChildren
  '/users/apk': typeof AuthUsersApkRouteWithChildren
  '/users/create-role': typeof AuthUsersCreateRoleRoute
  '/users/employees': typeof AuthUsersEmployeesRouteWithChildren
  '/users/parents': typeof AuthUsersParentsRouteWithChildren
  '/users/students': typeof AuthUsersStudentsRouteWithChildren
  '/auth/set-password': typeof LoginAuthSetPasswordRoute
  '/administration': typeof AuthAdministrationIndexRoute
  '/applications': typeof AuthApplicationsIndexRoute
  '/canteen': typeof AuthCanteenIndexRoute
  '/journal': typeof AuthJournalIndexRoute
  '/reports': typeof AuthReportsIndexRoute
  '/users': typeof AuthUsersIndexRoute
  '/login': typeof LoginLoginIndexRoute
  '/administration/monitoring/processes': typeof AuthAdministrationMonitoringProcessesRouteWithChildren
  '/administration/monitoring/queue': typeof AuthAdministrationMonitoringQueueRouteWithChildren
  '/administration/reference-books/cameras': typeof AuthAdministrationReferenceBooksCamerasRouteWithChildren
  '/administration/reference-books/canteens': typeof AuthAdministrationReferenceBooksCanteensRouteWithChildren
  '/administration/reference-books/company': typeof AuthAdministrationReferenceBooksCompanyRouteWithChildren
  '/administration/reference-books/schools': typeof AuthAdministrationReferenceBooksSchoolsRouteWithChildren
  '/administration/settings/$settingId': typeof AuthAdministrationSettingsSettingIdRoute
  '/administration/settings/create': typeof AuthAdministrationSettingsCreateRoute
  '/applications/manual-requests/manual-requests': typeof AuthApplicationsManualRequestsManualRequestsRouteWithChildren
  '/applications/manual-voucher-approval/$manualVoucherId': typeof AuthApplicationsManualVoucherApprovalManualVoucherIdRouteWithChildren
  '/applications/manual-voucher-confirmation/$voucherId': typeof AuthApplicationsManualVoucherConfirmationVoucherIdRoute
  '/applications/manual-voucher-confirmation/list': typeof AuthApplicationsManualVoucherConfirmationListRoute
  '/canteen/manual-attendance-and-food-receipt/list': typeof AuthCanteenManualAttendanceAndFoodReceiptListRoute
  '/canteen/menu-settings/dishes': typeof AuthCanteenMenuSettingsDishesRouteWithChildren
  '/journal/tabs/auth': typeof AuthJournalTabsAuthRoute
  '/journal/tabs/users': typeof AuthJournalTabsUsersRoute
  '/reports/attendance/create': typeof AuthReportsAttendanceCreateRoute
  '/reports/no-meal-vouchers/create': typeof AuthReportsNoMealVouchersCreateRoute
  '/reports/vouchers/create': typeof AuthReportsVouchersCreateRoute
  '/users/apk/list': typeof AuthUsersApkListRouteWithChildren
  '/users/apk/roles': typeof AuthUsersApkRolesRouteWithChildren
  '/users/employees/$employeeId': typeof AuthUsersEmployeesEmployeeIdRoute
  '/users/employees/create': typeof AuthUsersEmployeesCreateRoute
  '/users/parents/$parentId': typeof AuthUsersParentsParentIdRoute
  '/users/parents/create': typeof AuthUsersParentsCreateRoute
  '/users/role/$roleId': typeof AuthUsersRoleRoleIdRoute
  '/users/students/$studentId': typeof AuthUsersStudentsStudentIdRoute
  '/users/students/create': typeof AuthUsersStudentsCreateRoute
  '/users/update-role/$roleId': typeof AuthUsersUpdateRoleRoleIdRoute
  '/login/forgot-password/set-new-password': typeof LoginLoginForgotPasswordSetNewPasswordRoute
  '/login/forgot-password/verify-otp': typeof LoginLoginForgotPasswordVerifyOtpRoute
  '/administration/reference-books': typeof AuthAdministrationReferenceBooksIndexRoute
  '/applications/limitations': typeof AuthApplicationsLimitationsIndexRoute
  '/applications/manual-voucher-approval': typeof AuthApplicationsManualVoucherApprovalIndexRoute
  '/canteen/meal-restrictions': typeof AuthCanteenMealRestrictionsIndexRoute
  '/canteen/menu-settings': typeof AuthCanteenMenuSettingsIndexRoute
  '/login/forgot-password': typeof LoginLoginForgotPasswordIndexRoute
  '/administration/monitoring/processes/$processId': typeof AuthAdministrationMonitoringProcessesProcessIdRoute
  '/administration/monitoring/queue/$processId': typeof AuthAdministrationMonitoringQueueProcessIdRoute
  '/administration/reference-books/cameras/$cameraId': typeof AuthAdministrationReferenceBooksCamerasCameraIdRoute
  '/administration/reference-books/cameras/create': typeof AuthAdministrationReferenceBooksCamerasCreateRoute
  '/administration/reference-books/canteens/connects': typeof AuthAdministrationReferenceBooksCanteensConnectsRouteWithChildren
  '/administration/reference-books/canteens/list': typeof AuthAdministrationReferenceBooksCanteensListRouteWithChildren
  '/administration/reference-books/company/$companyId': typeof AuthAdministrationReferenceBooksCompanyCompanyIdRoute
  '/administration/reference-books/company/create': typeof AuthAdministrationReferenceBooksCompanyCreateRoute
  '/administration/reference-books/schools/$schoolId': typeof AuthAdministrationReferenceBooksSchoolsSchoolIdRoute
  '/administration/reference-books/schools/create': typeof AuthAdministrationReferenceBooksSchoolsCreateRoute
  '/administration/settings/update/$settingId': typeof AuthAdministrationSettingsUpdateSettingIdRoute
  '/applications/limitations/limitation/$limitationId': typeof AuthApplicationsLimitationsLimitationLimitationIdRouteWithChildren
  '/applications/manual-requests/manual-request/$requestId': typeof AuthApplicationsManualRequestsManualRequestRequestIdRouteWithChildren
  '/applications/manual-requests/manual-requests/create': typeof AuthApplicationsManualRequestsManualRequestsCreateRoute
  '/applications/manual-voucher-approval/$manualVoucherId/common': typeof AuthApplicationsManualVoucherApprovalManualVoucherIdCommonRoute
  '/applications/manual-voucher-approval/$manualVoucherId/history': typeof AuthApplicationsManualVoucherApprovalManualVoucherIdHistoryRoute
  '/applications/manual-voucher-approval/$manualVoucherId/items': typeof AuthApplicationsManualVoucherApprovalManualVoucherIdItemsRoute
  '/canteen/manual-attendance-and-food-receipt/item/$manualId': typeof AuthCanteenManualAttendanceAndFoodReceiptItemManualIdRoute
  '/canteen/manual-attendance-and-food-receipt/item/create': typeof AuthCanteenManualAttendanceAndFoodReceiptItemCreateRoute
  '/canteen/meal-restrictions/restriction/$restrictionId': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdRouteWithChildren
  '/canteen/menu-settings/catalog-menu/create': typeof AuthCanteenMenuSettingsCatalogMenuCreateRoute
  '/canteen/menu-settings/dishes/$dishId': typeof AuthCanteenMenuSettingsDishesDishIdRoute
  '/canteen/menu-settings/dishes/create': typeof AuthCanteenMenuSettingsDishesCreateRoute
  '/canteen/user-comments/comment/$commentId': typeof AuthCanteenUserCommentsCommentCommentIdRoute
  '/canteen/user-comments/dish/$dishId': typeof AuthCanteenUserCommentsDishDishIdRoute
  '/canteen/user-comments/student/$studentId': typeof AuthCanteenUserCommentsStudentStudentIdRoute
  '/reports/attendance/item/$reportId': typeof AuthReportsAttendanceItemReportIdRoute
  '/reports/no-meal-vouchers/item/$reportId': typeof AuthReportsNoMealVouchersItemReportIdRoute
  '/reports/vouchers/item/$reportId': typeof AuthReportsVouchersItemReportIdRoute
  '/users/apk/list/$userId': typeof AuthUsersApkListUserIdRoute
  '/users/apk/list/create': typeof AuthUsersApkListCreateRoute
  '/users/apk/roles/$roleId': typeof AuthUsersApkRolesRoleIdRoute
  '/users/employees/update/$employeeId': typeof AuthUsersEmployeesUpdateEmployeeIdRoute
  '/users/parents/update/$parentId': typeof AuthUsersParentsUpdateParentIdRoute
  '/users/students/update/$studentId': typeof AuthUsersStudentsUpdateStudentIdRoute
  '/canteen/menu-settings/catalog-menu': typeof AuthCanteenMenuSettingsCatalogMenuIndexRoute
  '/administration/reference-books/cameras/update/$cameraId': typeof AuthAdministrationReferenceBooksCamerasUpdateCameraIdRoute
  '/administration/reference-books/canteens/connects/$connectId': typeof AuthAdministrationReferenceBooksCanteensConnectsConnectIdRoute
  '/administration/reference-books/canteens/connects/create': typeof AuthAdministrationReferenceBooksCanteensConnectsCreateRoute
  '/administration/reference-books/canteens/list/$canteenId': typeof AuthAdministrationReferenceBooksCanteensListCanteenIdRoute
  '/administration/reference-books/canteens/list/create': typeof AuthAdministrationReferenceBooksCanteensListCreateRoute
  '/administration/reference-books/company/update/$companyId': typeof AuthAdministrationReferenceBooksCompanyUpdateCompanyIdRoute
  '/administration/reference-books/schools/update/$schoolId': typeof AuthAdministrationReferenceBooksSchoolsUpdateSchoolIdRoute
  '/applications/limitations/limitation/$limitationId/allergens': typeof AuthApplicationsLimitationsLimitationLimitationIdAllergensRouteWithChildren
  '/applications/limitations/limitation/$limitationId/common': typeof AuthApplicationsLimitationsLimitationLimitationIdCommonRouteWithChildren
  '/applications/limitations/limitation/$limitationId/history': typeof AuthApplicationsLimitationsLimitationLimitationIdHistoryRoute
  '/applications/manual-requests/manual-request/$requestId/common': typeof AuthApplicationsManualRequestsManualRequestRequestIdCommonRoute
  '/applications/manual-requests/manual-request/$requestId/history': typeof AuthApplicationsManualRequestsManualRequestRequestIdHistoryRoute
  '/canteen/meal-restrictions/restriction/$restrictionId/allergens': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRouteWithChildren
  '/canteen/meal-restrictions/restriction/$restrictionId/common': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRouteWithChildren
  '/canteen/menu-settings/catalog-menu/details/$menuCardId': typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRouteWithChildren
  '/canteen/menu-settings/catalog-menu/update/$menuId': typeof AuthCanteenMenuSettingsCatalogMenuUpdateMenuIdRoute
  '/canteen/menu-settings/dishes/update/$dishId': typeof AuthCanteenMenuSettingsDishesUpdateDishIdRoute
  '/users/apk/list/update/$userId': typeof AuthUsersApkListUpdateUserIdRoute
  '/users/apk/roles/update/$roleId': typeof AuthUsersApkRolesUpdateRoleIdRoute
  '/users/apk/roles/create': typeof AuthUsersApkRolesCreateIndexRoute
  '/administration/reference-books/canteens/connects/update/$connectId': typeof AuthAdministrationReferenceBooksCanteensConnectsUpdateConnectIdRoute
  '/administration/reference-books/canteens/list/update/$canteenId': typeof AuthAdministrationReferenceBooksCanteensListUpdateCanteenIdRoute
  '/canteen/menu-settings/catalog-menu/details/$menuCardId/common': typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdCommonRoute
  '/canteen/menu-settings/catalog-menu/details/$menuCardId/parameters': typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdParametersRoute
  '/applications/limitations/limitation/$limitationId/allergens/dish/$dishId': typeof AuthApplicationsLimitationsLimitationLimitationIdAllergensDishDishIdRoute
  '/applications/limitations/limitation/$limitationId/common/user/$userId': typeof AuthApplicationsLimitationsLimitationLimitationIdCommonUserUserIdRoute
  '/canteen/meal-restrictions/restriction/$restrictionId/allergens/dish/$dishId': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensDishDishIdRoute
  '/canteen/meal-restrictions/restriction/$restrictionId/common/user/$userId': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonUserUserIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_dashboard': typeof DashboardRouteWithChildren
  '/_login': typeof LoginRouteWithChildren
  '/canteen-dashboard': typeof CanteenDashboardRoute
  '/_auth/photo-rules': typeof AuthPhotoRulesRoute
  '/_dashboard/dashboard': typeof DashboardDashboardRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/administration/monitoring': typeof AuthAdministrationMonitoringRouteWithChildren
  '/_auth/administration/settings': typeof AuthAdministrationSettingsRouteWithChildren
  '/_auth/applications/manual-voucher-approval': typeof AuthApplicationsManualVoucherApprovalRouteWithChildren
  '/_auth/canteen/manual-voucher-approval': typeof AuthCanteenManualVoucherApprovalRoute
  '/_auth/canteen/meal-restrictions': typeof AuthCanteenMealRestrictionsRouteWithChildren
  '/_auth/canteen/user-comments': typeof AuthCanteenUserCommentsRouteWithChildren
  '/_auth/journal/tabs': typeof AuthJournalTabsRouteWithChildren
  '/_auth/reports/attendance': typeof AuthReportsAttendanceRouteWithChildren
  '/_auth/reports/dashboards': typeof AuthReportsDashboardsRoute
  '/_auth/reports/no-meal-vouchers': typeof AuthReportsNoMealVouchersRouteWithChildren
  '/_auth/reports/vouchers': typeof AuthReportsVouchersRouteWithChildren
  '/_auth/users/apk': typeof AuthUsersApkRouteWithChildren
  '/_auth/users/create-role': typeof AuthUsersCreateRoleRoute
  '/_auth/users/employees': typeof AuthUsersEmployeesRouteWithChildren
  '/_auth/users/parents': typeof AuthUsersParentsRouteWithChildren
  '/_auth/users/students': typeof AuthUsersStudentsRouteWithChildren
  '/_login/auth/set-password': typeof LoginAuthSetPasswordRoute
  '/_auth/administration/': typeof AuthAdministrationIndexRoute
  '/_auth/applications/': typeof AuthApplicationsIndexRoute
  '/_auth/canteen/': typeof AuthCanteenIndexRoute
  '/_auth/journal/': typeof AuthJournalIndexRoute
  '/_auth/reports/': typeof AuthReportsIndexRoute
  '/_auth/users/': typeof AuthUsersIndexRoute
  '/_login/login/': typeof LoginLoginIndexRoute
  '/_auth/administration/monitoring/processes': typeof AuthAdministrationMonitoringProcessesRouteWithChildren
  '/_auth/administration/monitoring/queue': typeof AuthAdministrationMonitoringQueueRouteWithChildren
  '/_auth/administration/reference-books/cameras': typeof AuthAdministrationReferenceBooksCamerasRouteWithChildren
  '/_auth/administration/reference-books/canteens': typeof AuthAdministrationReferenceBooksCanteensRouteWithChildren
  '/_auth/administration/reference-books/company': typeof AuthAdministrationReferenceBooksCompanyRouteWithChildren
  '/_auth/administration/reference-books/schools': typeof AuthAdministrationReferenceBooksSchoolsRouteWithChildren
  '/_auth/administration/settings/$settingId': typeof AuthAdministrationSettingsSettingIdRoute
  '/_auth/administration/settings/create': typeof AuthAdministrationSettingsCreateRoute
  '/_auth/applications/manual-requests/manual-requests': typeof AuthApplicationsManualRequestsManualRequestsRouteWithChildren
  '/_auth/applications/manual-voucher-approval/$manualVoucherId': typeof AuthApplicationsManualVoucherApprovalManualVoucherIdRouteWithChildren
  '/_auth/applications/manual-voucher-confirmation/$voucherId': typeof AuthApplicationsManualVoucherConfirmationVoucherIdRoute
  '/_auth/applications/manual-voucher-confirmation/list': typeof AuthApplicationsManualVoucherConfirmationListRoute
  '/_auth/canteen/manual-attendance-and-food-receipt/list': typeof AuthCanteenManualAttendanceAndFoodReceiptListRoute
  '/_auth/canteen/menu-settings/catalog-menu': typeof AuthCanteenMenuSettingsCatalogMenuRouteWithChildren
  '/_auth/canteen/menu-settings/dishes': typeof AuthCanteenMenuSettingsDishesRouteWithChildren
  '/_auth/journal/tabs/auth': typeof AuthJournalTabsAuthRoute
  '/_auth/journal/tabs/users': typeof AuthJournalTabsUsersRoute
  '/_auth/reports/attendance/create': typeof AuthReportsAttendanceCreateRoute
  '/_auth/reports/no-meal-vouchers/create': typeof AuthReportsNoMealVouchersCreateRoute
  '/_auth/reports/vouchers/create': typeof AuthReportsVouchersCreateRoute
  '/_auth/users/apk/list': typeof AuthUsersApkListRouteWithChildren
  '/_auth/users/apk/roles': typeof AuthUsersApkRolesRouteWithChildren
  '/_auth/users/employees/$employeeId': typeof AuthUsersEmployeesEmployeeIdRoute
  '/_auth/users/employees/create': typeof AuthUsersEmployeesCreateRoute
  '/_auth/users/parents/$parentId': typeof AuthUsersParentsParentIdRoute
  '/_auth/users/parents/create': typeof AuthUsersParentsCreateRoute
  '/_auth/users/role/$roleId': typeof AuthUsersRoleRoleIdRoute
  '/_auth/users/students/$studentId': typeof AuthUsersStudentsStudentIdRoute
  '/_auth/users/students/create': typeof AuthUsersStudentsCreateRoute
  '/_auth/users/update-role/$roleId': typeof AuthUsersUpdateRoleRoleIdRoute
  '/_login/login/forgot-password/set-new-password': typeof LoginLoginForgotPasswordSetNewPasswordRoute
  '/_login/login/forgot-password/verify-otp': typeof LoginLoginForgotPasswordVerifyOtpRoute
  '/_auth/administration/reference-books/': typeof AuthAdministrationReferenceBooksIndexRoute
  '/_auth/applications/limitations/': typeof AuthApplicationsLimitationsIndexRoute
  '/_auth/applications/manual-voucher-approval/': typeof AuthApplicationsManualVoucherApprovalIndexRoute
  '/_auth/canteen/meal-restrictions/': typeof AuthCanteenMealRestrictionsIndexRoute
  '/_auth/canteen/menu-settings/': typeof AuthCanteenMenuSettingsIndexRoute
  '/_login/login/forgot-password/': typeof LoginLoginForgotPasswordIndexRoute
  '/_auth/administration/monitoring/processes/$processId': typeof AuthAdministrationMonitoringProcessesProcessIdRoute
  '/_auth/administration/monitoring/queue/$processId': typeof AuthAdministrationMonitoringQueueProcessIdRoute
  '/_auth/administration/reference-books/cameras/$cameraId': typeof AuthAdministrationReferenceBooksCamerasCameraIdRoute
  '/_auth/administration/reference-books/cameras/create': typeof AuthAdministrationReferenceBooksCamerasCreateRoute
  '/_auth/administration/reference-books/canteens/connects': typeof AuthAdministrationReferenceBooksCanteensConnectsRouteWithChildren
  '/_auth/administration/reference-books/canteens/list': typeof AuthAdministrationReferenceBooksCanteensListRouteWithChildren
  '/_auth/administration/reference-books/company/$companyId': typeof AuthAdministrationReferenceBooksCompanyCompanyIdRoute
  '/_auth/administration/reference-books/company/create': typeof AuthAdministrationReferenceBooksCompanyCreateRoute
  '/_auth/administration/reference-books/schools/$schoolId': typeof AuthAdministrationReferenceBooksSchoolsSchoolIdRoute
  '/_auth/administration/reference-books/schools/create': typeof AuthAdministrationReferenceBooksSchoolsCreateRoute
  '/_auth/administration/settings/update/$settingId': typeof AuthAdministrationSettingsUpdateSettingIdRoute
  '/_auth/applications/limitations/limitation/$limitationId': typeof AuthApplicationsLimitationsLimitationLimitationIdRouteWithChildren
  '/_auth/applications/manual-requests/manual-request/$requestId': typeof AuthApplicationsManualRequestsManualRequestRequestIdRouteWithChildren
  '/_auth/applications/manual-requests/manual-requests/create': typeof AuthApplicationsManualRequestsManualRequestsCreateRoute
  '/_auth/applications/manual-voucher-approval/$manualVoucherId/common': typeof AuthApplicationsManualVoucherApprovalManualVoucherIdCommonRoute
  '/_auth/applications/manual-voucher-approval/$manualVoucherId/history': typeof AuthApplicationsManualVoucherApprovalManualVoucherIdHistoryRoute
  '/_auth/applications/manual-voucher-approval/$manualVoucherId/items': typeof AuthApplicationsManualVoucherApprovalManualVoucherIdItemsRoute
  '/_auth/canteen/manual-attendance-and-food-receipt/item/$manualId': typeof AuthCanteenManualAttendanceAndFoodReceiptItemManualIdRoute
  '/_auth/canteen/manual-attendance-and-food-receipt/item/create': typeof AuthCanteenManualAttendanceAndFoodReceiptItemCreateRoute
  '/_auth/canteen/meal-restrictions/restriction/$restrictionId': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdRouteWithChildren
  '/_auth/canteen/menu-settings/catalog-menu/create': typeof AuthCanteenMenuSettingsCatalogMenuCreateRoute
  '/_auth/canteen/menu-settings/dishes/$dishId': typeof AuthCanteenMenuSettingsDishesDishIdRoute
  '/_auth/canteen/menu-settings/dishes/create': typeof AuthCanteenMenuSettingsDishesCreateRoute
  '/_auth/canteen/user-comments/comment/$commentId': typeof AuthCanteenUserCommentsCommentCommentIdRoute
  '/_auth/canteen/user-comments/dish/$dishId': typeof AuthCanteenUserCommentsDishDishIdRoute
  '/_auth/canteen/user-comments/student/$studentId': typeof AuthCanteenUserCommentsStudentStudentIdRoute
  '/_auth/reports/attendance_/item/$reportId': typeof AuthReportsAttendanceItemReportIdRoute
  '/_auth/reports/no-meal-vouchers_/item/$reportId': typeof AuthReportsNoMealVouchersItemReportIdRoute
  '/_auth/reports/vouchers_/item/$reportId': typeof AuthReportsVouchersItemReportIdRoute
  '/_auth/users/apk/list/$userId': typeof AuthUsersApkListUserIdRoute
  '/_auth/users/apk/list/create': typeof AuthUsersApkListCreateRoute
  '/_auth/users/apk/roles/$roleId': typeof AuthUsersApkRolesRoleIdRoute
  '/_auth/users/employees/update/$employeeId': typeof AuthUsersEmployeesUpdateEmployeeIdRoute
  '/_auth/users/parents/update/$parentId': typeof AuthUsersParentsUpdateParentIdRoute
  '/_auth/users/students/update/$studentId': typeof AuthUsersStudentsUpdateStudentIdRoute
  '/_auth/canteen/menu-settings/catalog-menu/': typeof AuthCanteenMenuSettingsCatalogMenuIndexRoute
  '/_auth/administration/reference-books/cameras/update/$cameraId': typeof AuthAdministrationReferenceBooksCamerasUpdateCameraIdRoute
  '/_auth/administration/reference-books/canteens/connects/$connectId': typeof AuthAdministrationReferenceBooksCanteensConnectsConnectIdRoute
  '/_auth/administration/reference-books/canteens/connects/create': typeof AuthAdministrationReferenceBooksCanteensConnectsCreateRoute
  '/_auth/administration/reference-books/canteens/list/$canteenId': typeof AuthAdministrationReferenceBooksCanteensListCanteenIdRoute
  '/_auth/administration/reference-books/canteens/list/create': typeof AuthAdministrationReferenceBooksCanteensListCreateRoute
  '/_auth/administration/reference-books/company/update/$companyId': typeof AuthAdministrationReferenceBooksCompanyUpdateCompanyIdRoute
  '/_auth/administration/reference-books/schools/update/$schoolId': typeof AuthAdministrationReferenceBooksSchoolsUpdateSchoolIdRoute
  '/_auth/applications/limitations/limitation/$limitationId/allergens': typeof AuthApplicationsLimitationsLimitationLimitationIdAllergensRouteWithChildren
  '/_auth/applications/limitations/limitation/$limitationId/common': typeof AuthApplicationsLimitationsLimitationLimitationIdCommonRouteWithChildren
  '/_auth/applications/limitations/limitation/$limitationId/history': typeof AuthApplicationsLimitationsLimitationLimitationIdHistoryRoute
  '/_auth/applications/manual-requests/manual-request/$requestId/common': typeof AuthApplicationsManualRequestsManualRequestRequestIdCommonRoute
  '/_auth/applications/manual-requests/manual-request/$requestId/history': typeof AuthApplicationsManualRequestsManualRequestRequestIdHistoryRoute
  '/_auth/canteen/meal-restrictions/restriction/$restrictionId/allergens': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRouteWithChildren
  '/_auth/canteen/meal-restrictions/restriction/$restrictionId/common': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRouteWithChildren
  '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId': typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRouteWithChildren
  '/_auth/canteen/menu-settings/catalog-menu/update/$menuId': typeof AuthCanteenMenuSettingsCatalogMenuUpdateMenuIdRoute
  '/_auth/canteen/menu-settings/dishes/update/$dishId': typeof AuthCanteenMenuSettingsDishesUpdateDishIdRoute
  '/_auth/users/apk/list/update/$userId': typeof AuthUsersApkListUpdateUserIdRoute
  '/_auth/users/apk/roles/update/$roleId': typeof AuthUsersApkRolesUpdateRoleIdRoute
  '/_auth/users/apk/roles/create/': typeof AuthUsersApkRolesCreateIndexRoute
  '/_auth/administration/reference-books/canteens/connects/update/$connectId': typeof AuthAdministrationReferenceBooksCanteensConnectsUpdateConnectIdRoute
  '/_auth/administration/reference-books/canteens/list/update/$canteenId': typeof AuthAdministrationReferenceBooksCanteensListUpdateCanteenIdRoute
  '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId/common': typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdCommonRoute
  '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId/parameters': typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdParametersRoute
  '/_auth/applications/limitations/limitation/$limitationId/allergens/dish/$dishId': typeof AuthApplicationsLimitationsLimitationLimitationIdAllergensDishDishIdRoute
  '/_auth/applications/limitations/limitation/$limitationId/common/user/$userId': typeof AuthApplicationsLimitationsLimitationLimitationIdCommonUserUserIdRoute
  '/_auth/canteen/meal-restrictions/restriction/$restrictionId/allergens/dish/$dishId': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensDishDishIdRoute
  '/_auth/canteen/meal-restrictions/restriction/$restrictionId/common/user/$userId': typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonUserUserIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/canteen-dashboard'
    | '/photo-rules'
    | '/dashboard'
    | '/administration/monitoring'
    | '/administration/settings'
    | '/applications/manual-voucher-approval'
    | '/canteen/manual-voucher-approval'
    | '/canteen/meal-restrictions'
    | '/canteen/user-comments'
    | '/journal/tabs'
    | '/reports/attendance'
    | '/reports/dashboards'
    | '/reports/no-meal-vouchers'
    | '/reports/vouchers'
    | '/users/apk'
    | '/users/create-role'
    | '/users/employees'
    | '/users/parents'
    | '/users/students'
    | '/auth/set-password'
    | '/administration/'
    | '/applications/'
    | '/canteen/'
    | '/journal/'
    | '/reports/'
    | '/users/'
    | '/login/'
    | '/administration/monitoring/processes'
    | '/administration/monitoring/queue'
    | '/administration/reference-books/cameras'
    | '/administration/reference-books/canteens'
    | '/administration/reference-books/company'
    | '/administration/reference-books/schools'
    | '/administration/settings/$settingId'
    | '/administration/settings/create'
    | '/applications/manual-requests/manual-requests'
    | '/applications/manual-voucher-approval/$manualVoucherId'
    | '/applications/manual-voucher-confirmation/$voucherId'
    | '/applications/manual-voucher-confirmation/list'
    | '/canteen/manual-attendance-and-food-receipt/list'
    | '/canteen/menu-settings/catalog-menu'
    | '/canteen/menu-settings/dishes'
    | '/journal/tabs/auth'
    | '/journal/tabs/users'
    | '/reports/attendance/create'
    | '/reports/no-meal-vouchers/create'
    | '/reports/vouchers/create'
    | '/users/apk/list'
    | '/users/apk/roles'
    | '/users/employees/$employeeId'
    | '/users/employees/create'
    | '/users/parents/$parentId'
    | '/users/parents/create'
    | '/users/role/$roleId'
    | '/users/students/$studentId'
    | '/users/students/create'
    | '/users/update-role/$roleId'
    | '/login/forgot-password/set-new-password'
    | '/login/forgot-password/verify-otp'
    | '/administration/reference-books/'
    | '/applications/limitations/'
    | '/applications/manual-voucher-approval/'
    | '/canteen/meal-restrictions/'
    | '/canteen/menu-settings/'
    | '/login/forgot-password/'
    | '/administration/monitoring/processes/$processId'
    | '/administration/monitoring/queue/$processId'
    | '/administration/reference-books/cameras/$cameraId'
    | '/administration/reference-books/cameras/create'
    | '/administration/reference-books/canteens/connects'
    | '/administration/reference-books/canteens/list'
    | '/administration/reference-books/company/$companyId'
    | '/administration/reference-books/company/create'
    | '/administration/reference-books/schools/$schoolId'
    | '/administration/reference-books/schools/create'
    | '/administration/settings/update/$settingId'
    | '/applications/limitations/limitation/$limitationId'
    | '/applications/manual-requests/manual-request/$requestId'
    | '/applications/manual-requests/manual-requests/create'
    | '/applications/manual-voucher-approval/$manualVoucherId/common'
    | '/applications/manual-voucher-approval/$manualVoucherId/history'
    | '/applications/manual-voucher-approval/$manualVoucherId/items'
    | '/canteen/manual-attendance-and-food-receipt/item/$manualId'
    | '/canteen/manual-attendance-and-food-receipt/item/create'
    | '/canteen/meal-restrictions/restriction/$restrictionId'
    | '/canteen/menu-settings/catalog-menu/create'
    | '/canteen/menu-settings/dishes/$dishId'
    | '/canteen/menu-settings/dishes/create'
    | '/canteen/user-comments/comment/$commentId'
    | '/canteen/user-comments/dish/$dishId'
    | '/canteen/user-comments/student/$studentId'
    | '/reports/attendance/item/$reportId'
    | '/reports/no-meal-vouchers/item/$reportId'
    | '/reports/vouchers/item/$reportId'
    | '/users/apk/list/$userId'
    | '/users/apk/list/create'
    | '/users/apk/roles/$roleId'
    | '/users/employees/update/$employeeId'
    | '/users/parents/update/$parentId'
    | '/users/students/update/$studentId'
    | '/canteen/menu-settings/catalog-menu/'
    | '/administration/reference-books/cameras/update/$cameraId'
    | '/administration/reference-books/canteens/connects/$connectId'
    | '/administration/reference-books/canteens/connects/create'
    | '/administration/reference-books/canteens/list/$canteenId'
    | '/administration/reference-books/canteens/list/create'
    | '/administration/reference-books/company/update/$companyId'
    | '/administration/reference-books/schools/update/$schoolId'
    | '/applications/limitations/limitation/$limitationId/allergens'
    | '/applications/limitations/limitation/$limitationId/common'
    | '/applications/limitations/limitation/$limitationId/history'
    | '/applications/manual-requests/manual-request/$requestId/common'
    | '/applications/manual-requests/manual-request/$requestId/history'
    | '/canteen/meal-restrictions/restriction/$restrictionId/allergens'
    | '/canteen/meal-restrictions/restriction/$restrictionId/common'
    | '/canteen/menu-settings/catalog-menu/details/$menuCardId'
    | '/canteen/menu-settings/catalog-menu/update/$menuId'
    | '/canteen/menu-settings/dishes/update/$dishId'
    | '/users/apk/list/update/$userId'
    | '/users/apk/roles/update/$roleId'
    | '/users/apk/roles/create/'
    | '/administration/reference-books/canteens/connects/update/$connectId'
    | '/administration/reference-books/canteens/list/update/$canteenId'
    | '/canteen/menu-settings/catalog-menu/details/$menuCardId/common'
    | '/canteen/menu-settings/catalog-menu/details/$menuCardId/parameters'
    | '/applications/limitations/limitation/$limitationId/allergens/dish/$dishId'
    | '/applications/limitations/limitation/$limitationId/common/user/$userId'
    | '/canteen/meal-restrictions/restriction/$restrictionId/allergens/dish/$dishId'
    | '/canteen/meal-restrictions/restriction/$restrictionId/common/user/$userId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/canteen-dashboard'
    | '/photo-rules'
    | '/dashboard'
    | '/administration/monitoring'
    | '/administration/settings'
    | '/canteen/manual-voucher-approval'
    | '/canteen/user-comments'
    | '/journal/tabs'
    | '/reports/attendance'
    | '/reports/dashboards'
    | '/reports/no-meal-vouchers'
    | '/reports/vouchers'
    | '/users/apk'
    | '/users/create-role'
    | '/users/employees'
    | '/users/parents'
    | '/users/students'
    | '/auth/set-password'
    | '/administration'
    | '/applications'
    | '/canteen'
    | '/journal'
    | '/reports'
    | '/users'
    | '/login'
    | '/administration/monitoring/processes'
    | '/administration/monitoring/queue'
    | '/administration/reference-books/cameras'
    | '/administration/reference-books/canteens'
    | '/administration/reference-books/company'
    | '/administration/reference-books/schools'
    | '/administration/settings/$settingId'
    | '/administration/settings/create'
    | '/applications/manual-requests/manual-requests'
    | '/applications/manual-voucher-approval/$manualVoucherId'
    | '/applications/manual-voucher-confirmation/$voucherId'
    | '/applications/manual-voucher-confirmation/list'
    | '/canteen/manual-attendance-and-food-receipt/list'
    | '/canteen/menu-settings/dishes'
    | '/journal/tabs/auth'
    | '/journal/tabs/users'
    | '/reports/attendance/create'
    | '/reports/no-meal-vouchers/create'
    | '/reports/vouchers/create'
    | '/users/apk/list'
    | '/users/apk/roles'
    | '/users/employees/$employeeId'
    | '/users/employees/create'
    | '/users/parents/$parentId'
    | '/users/parents/create'
    | '/users/role/$roleId'
    | '/users/students/$studentId'
    | '/users/students/create'
    | '/users/update-role/$roleId'
    | '/login/forgot-password/set-new-password'
    | '/login/forgot-password/verify-otp'
    | '/administration/reference-books'
    | '/applications/limitations'
    | '/applications/manual-voucher-approval'
    | '/canteen/meal-restrictions'
    | '/canteen/menu-settings'
    | '/login/forgot-password'
    | '/administration/monitoring/processes/$processId'
    | '/administration/monitoring/queue/$processId'
    | '/administration/reference-books/cameras/$cameraId'
    | '/administration/reference-books/cameras/create'
    | '/administration/reference-books/canteens/connects'
    | '/administration/reference-books/canteens/list'
    | '/administration/reference-books/company/$companyId'
    | '/administration/reference-books/company/create'
    | '/administration/reference-books/schools/$schoolId'
    | '/administration/reference-books/schools/create'
    | '/administration/settings/update/$settingId'
    | '/applications/limitations/limitation/$limitationId'
    | '/applications/manual-requests/manual-request/$requestId'
    | '/applications/manual-requests/manual-requests/create'
    | '/applications/manual-voucher-approval/$manualVoucherId/common'
    | '/applications/manual-voucher-approval/$manualVoucherId/history'
    | '/applications/manual-voucher-approval/$manualVoucherId/items'
    | '/canteen/manual-attendance-and-food-receipt/item/$manualId'
    | '/canteen/manual-attendance-and-food-receipt/item/create'
    | '/canteen/meal-restrictions/restriction/$restrictionId'
    | '/canteen/menu-settings/catalog-menu/create'
    | '/canteen/menu-settings/dishes/$dishId'
    | '/canteen/menu-settings/dishes/create'
    | '/canteen/user-comments/comment/$commentId'
    | '/canteen/user-comments/dish/$dishId'
    | '/canteen/user-comments/student/$studentId'
    | '/reports/attendance/item/$reportId'
    | '/reports/no-meal-vouchers/item/$reportId'
    | '/reports/vouchers/item/$reportId'
    | '/users/apk/list/$userId'
    | '/users/apk/list/create'
    | '/users/apk/roles/$roleId'
    | '/users/employees/update/$employeeId'
    | '/users/parents/update/$parentId'
    | '/users/students/update/$studentId'
    | '/canteen/menu-settings/catalog-menu'
    | '/administration/reference-books/cameras/update/$cameraId'
    | '/administration/reference-books/canteens/connects/$connectId'
    | '/administration/reference-books/canteens/connects/create'
    | '/administration/reference-books/canteens/list/$canteenId'
    | '/administration/reference-books/canteens/list/create'
    | '/administration/reference-books/company/update/$companyId'
    | '/administration/reference-books/schools/update/$schoolId'
    | '/applications/limitations/limitation/$limitationId/allergens'
    | '/applications/limitations/limitation/$limitationId/common'
    | '/applications/limitations/limitation/$limitationId/history'
    | '/applications/manual-requests/manual-request/$requestId/common'
    | '/applications/manual-requests/manual-request/$requestId/history'
    | '/canteen/meal-restrictions/restriction/$restrictionId/allergens'
    | '/canteen/meal-restrictions/restriction/$restrictionId/common'
    | '/canteen/menu-settings/catalog-menu/details/$menuCardId'
    | '/canteen/menu-settings/catalog-menu/update/$menuId'
    | '/canteen/menu-settings/dishes/update/$dishId'
    | '/users/apk/list/update/$userId'
    | '/users/apk/roles/update/$roleId'
    | '/users/apk/roles/create'
    | '/administration/reference-books/canteens/connects/update/$connectId'
    | '/administration/reference-books/canteens/list/update/$canteenId'
    | '/canteen/menu-settings/catalog-menu/details/$menuCardId/common'
    | '/canteen/menu-settings/catalog-menu/details/$menuCardId/parameters'
    | '/applications/limitations/limitation/$limitationId/allergens/dish/$dishId'
    | '/applications/limitations/limitation/$limitationId/common/user/$userId'
    | '/canteen/meal-restrictions/restriction/$restrictionId/allergens/dish/$dishId'
    | '/canteen/meal-restrictions/restriction/$restrictionId/common/user/$userId'
  id:
    | '__root__'
    | '/_auth'
    | '/_dashboard'
    | '/_login'
    | '/canteen-dashboard'
    | '/_auth/photo-rules'
    | '/_dashboard/dashboard'
    | '/_auth/'
    | '/_auth/administration/monitoring'
    | '/_auth/administration/settings'
    | '/_auth/applications/manual-voucher-approval'
    | '/_auth/canteen/manual-voucher-approval'
    | '/_auth/canteen/meal-restrictions'
    | '/_auth/canteen/user-comments'
    | '/_auth/journal/tabs'
    | '/_auth/reports/attendance'
    | '/_auth/reports/dashboards'
    | '/_auth/reports/no-meal-vouchers'
    | '/_auth/reports/vouchers'
    | '/_auth/users/apk'
    | '/_auth/users/create-role'
    | '/_auth/users/employees'
    | '/_auth/users/parents'
    | '/_auth/users/students'
    | '/_login/auth/set-password'
    | '/_auth/administration/'
    | '/_auth/applications/'
    | '/_auth/canteen/'
    | '/_auth/journal/'
    | '/_auth/reports/'
    | '/_auth/users/'
    | '/_login/login/'
    | '/_auth/administration/monitoring/processes'
    | '/_auth/administration/monitoring/queue'
    | '/_auth/administration/reference-books/cameras'
    | '/_auth/administration/reference-books/canteens'
    | '/_auth/administration/reference-books/company'
    | '/_auth/administration/reference-books/schools'
    | '/_auth/administration/settings/$settingId'
    | '/_auth/administration/settings/create'
    | '/_auth/applications/manual-requests/manual-requests'
    | '/_auth/applications/manual-voucher-approval/$manualVoucherId'
    | '/_auth/applications/manual-voucher-confirmation/$voucherId'
    | '/_auth/applications/manual-voucher-confirmation/list'
    | '/_auth/canteen/manual-attendance-and-food-receipt/list'
    | '/_auth/canteen/menu-settings/catalog-menu'
    | '/_auth/canteen/menu-settings/dishes'
    | '/_auth/journal/tabs/auth'
    | '/_auth/journal/tabs/users'
    | '/_auth/reports/attendance/create'
    | '/_auth/reports/no-meal-vouchers/create'
    | '/_auth/reports/vouchers/create'
    | '/_auth/users/apk/list'
    | '/_auth/users/apk/roles'
    | '/_auth/users/employees/$employeeId'
    | '/_auth/users/employees/create'
    | '/_auth/users/parents/$parentId'
    | '/_auth/users/parents/create'
    | '/_auth/users/role/$roleId'
    | '/_auth/users/students/$studentId'
    | '/_auth/users/students/create'
    | '/_auth/users/update-role/$roleId'
    | '/_login/login/forgot-password/set-new-password'
    | '/_login/login/forgot-password/verify-otp'
    | '/_auth/administration/reference-books/'
    | '/_auth/applications/limitations/'
    | '/_auth/applications/manual-voucher-approval/'
    | '/_auth/canteen/meal-restrictions/'
    | '/_auth/canteen/menu-settings/'
    | '/_login/login/forgot-password/'
    | '/_auth/administration/monitoring/processes/$processId'
    | '/_auth/administration/monitoring/queue/$processId'
    | '/_auth/administration/reference-books/cameras/$cameraId'
    | '/_auth/administration/reference-books/cameras/create'
    | '/_auth/administration/reference-books/canteens/connects'
    | '/_auth/administration/reference-books/canteens/list'
    | '/_auth/administration/reference-books/company/$companyId'
    | '/_auth/administration/reference-books/company/create'
    | '/_auth/administration/reference-books/schools/$schoolId'
    | '/_auth/administration/reference-books/schools/create'
    | '/_auth/administration/settings/update/$settingId'
    | '/_auth/applications/limitations/limitation/$limitationId'
    | '/_auth/applications/manual-requests/manual-request/$requestId'
    | '/_auth/applications/manual-requests/manual-requests/create'
    | '/_auth/applications/manual-voucher-approval/$manualVoucherId/common'
    | '/_auth/applications/manual-voucher-approval/$manualVoucherId/history'
    | '/_auth/applications/manual-voucher-approval/$manualVoucherId/items'
    | '/_auth/canteen/manual-attendance-and-food-receipt/item/$manualId'
    | '/_auth/canteen/manual-attendance-and-food-receipt/item/create'
    | '/_auth/canteen/meal-restrictions/restriction/$restrictionId'
    | '/_auth/canteen/menu-settings/catalog-menu/create'
    | '/_auth/canteen/menu-settings/dishes/$dishId'
    | '/_auth/canteen/menu-settings/dishes/create'
    | '/_auth/canteen/user-comments/comment/$commentId'
    | '/_auth/canteen/user-comments/dish/$dishId'
    | '/_auth/canteen/user-comments/student/$studentId'
    | '/_auth/reports/attendance_/item/$reportId'
    | '/_auth/reports/no-meal-vouchers_/item/$reportId'
    | '/_auth/reports/vouchers_/item/$reportId'
    | '/_auth/users/apk/list/$userId'
    | '/_auth/users/apk/list/create'
    | '/_auth/users/apk/roles/$roleId'
    | '/_auth/users/employees/update/$employeeId'
    | '/_auth/users/parents/update/$parentId'
    | '/_auth/users/students/update/$studentId'
    | '/_auth/canteen/menu-settings/catalog-menu/'
    | '/_auth/administration/reference-books/cameras/update/$cameraId'
    | '/_auth/administration/reference-books/canteens/connects/$connectId'
    | '/_auth/administration/reference-books/canteens/connects/create'
    | '/_auth/administration/reference-books/canteens/list/$canteenId'
    | '/_auth/administration/reference-books/canteens/list/create'
    | '/_auth/administration/reference-books/company/update/$companyId'
    | '/_auth/administration/reference-books/schools/update/$schoolId'
    | '/_auth/applications/limitations/limitation/$limitationId/allergens'
    | '/_auth/applications/limitations/limitation/$limitationId/common'
    | '/_auth/applications/limitations/limitation/$limitationId/history'
    | '/_auth/applications/manual-requests/manual-request/$requestId/common'
    | '/_auth/applications/manual-requests/manual-request/$requestId/history'
    | '/_auth/canteen/meal-restrictions/restriction/$restrictionId/allergens'
    | '/_auth/canteen/meal-restrictions/restriction/$restrictionId/common'
    | '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId'
    | '/_auth/canteen/menu-settings/catalog-menu/update/$menuId'
    | '/_auth/canteen/menu-settings/dishes/update/$dishId'
    | '/_auth/users/apk/list/update/$userId'
    | '/_auth/users/apk/roles/update/$roleId'
    | '/_auth/users/apk/roles/create/'
    | '/_auth/administration/reference-books/canteens/connects/update/$connectId'
    | '/_auth/administration/reference-books/canteens/list/update/$canteenId'
    | '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId/common'
    | '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId/parameters'
    | '/_auth/applications/limitations/limitation/$limitationId/allergens/dish/$dishId'
    | '/_auth/applications/limitations/limitation/$limitationId/common/user/$userId'
    | '/_auth/canteen/meal-restrictions/restriction/$restrictionId/allergens/dish/$dishId'
    | '/_auth/canteen/meal-restrictions/restriction/$restrictionId/common/user/$userId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
  LoginRoute: typeof LoginRouteWithChildren
  CanteenDashboardRoute: typeof CanteenDashboardRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/canteen-dashboard': {
      id: '/canteen-dashboard'
      path: '/canteen-dashboard'
      fullPath: '/canteen-dashboard'
      preLoaderRoute: typeof CanteenDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_login': {
      id: '/_login'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_dashboard/dashboard': {
      id: '/_dashboard/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardDashboardRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_auth/photo-rules': {
      id: '/_auth/photo-rules'
      path: '/photo-rules'
      fullPath: '/photo-rules'
      preLoaderRoute: typeof AuthPhotoRulesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_login/login/': {
      id: '/_login/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginLoginIndexRouteImport
      parentRoute: typeof LoginRoute
    }
    '/_auth/users/': {
      id: '/_auth/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthUsersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/': {
      id: '/_auth/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthReportsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/journal/': {
      id: '/_auth/journal/'
      path: '/journal'
      fullPath: '/journal/'
      preLoaderRoute: typeof AuthJournalIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/canteen/': {
      id: '/_auth/canteen/'
      path: '/canteen'
      fullPath: '/canteen/'
      preLoaderRoute: typeof AuthCanteenIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/applications/': {
      id: '/_auth/applications/'
      path: '/applications'
      fullPath: '/applications/'
      preLoaderRoute: typeof AuthApplicationsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/': {
      id: '/_auth/administration/'
      path: '/administration'
      fullPath: '/administration/'
      preLoaderRoute: typeof AuthAdministrationIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_login/auth/set-password': {
      id: '/_login/auth/set-password'
      path: '/auth/set-password'
      fullPath: '/auth/set-password'
      preLoaderRoute: typeof LoginAuthSetPasswordRouteImport
      parentRoute: typeof LoginRoute
    }
    '/_auth/users/students': {
      id: '/_auth/users/students'
      path: '/users/students'
      fullPath: '/users/students'
      preLoaderRoute: typeof AuthUsersStudentsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/parents': {
      id: '/_auth/users/parents'
      path: '/users/parents'
      fullPath: '/users/parents'
      preLoaderRoute: typeof AuthUsersParentsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/employees': {
      id: '/_auth/users/employees'
      path: '/users/employees'
      fullPath: '/users/employees'
      preLoaderRoute: typeof AuthUsersEmployeesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/create-role': {
      id: '/_auth/users/create-role'
      path: '/users/create-role'
      fullPath: '/users/create-role'
      preLoaderRoute: typeof AuthUsersCreateRoleRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/apk': {
      id: '/_auth/users/apk'
      path: '/users/apk'
      fullPath: '/users/apk'
      preLoaderRoute: typeof AuthUsersApkRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/vouchers': {
      id: '/_auth/reports/vouchers'
      path: '/reports/vouchers'
      fullPath: '/reports/vouchers'
      preLoaderRoute: typeof AuthReportsVouchersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/no-meal-vouchers': {
      id: '/_auth/reports/no-meal-vouchers'
      path: '/reports/no-meal-vouchers'
      fullPath: '/reports/no-meal-vouchers'
      preLoaderRoute: typeof AuthReportsNoMealVouchersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/dashboards': {
      id: '/_auth/reports/dashboards'
      path: '/reports/dashboards'
      fullPath: '/reports/dashboards'
      preLoaderRoute: typeof AuthReportsDashboardsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/attendance': {
      id: '/_auth/reports/attendance'
      path: '/reports/attendance'
      fullPath: '/reports/attendance'
      preLoaderRoute: typeof AuthReportsAttendanceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/journal/tabs': {
      id: '/_auth/journal/tabs'
      path: '/journal/tabs'
      fullPath: '/journal/tabs'
      preLoaderRoute: typeof AuthJournalTabsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/canteen/user-comments': {
      id: '/_auth/canteen/user-comments'
      path: '/canteen/user-comments'
      fullPath: '/canteen/user-comments'
      preLoaderRoute: typeof AuthCanteenUserCommentsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/canteen/meal-restrictions': {
      id: '/_auth/canteen/meal-restrictions'
      path: '/canteen/meal-restrictions'
      fullPath: '/canteen/meal-restrictions'
      preLoaderRoute: typeof AuthCanteenMealRestrictionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/canteen/manual-voucher-approval': {
      id: '/_auth/canteen/manual-voucher-approval'
      path: '/canteen/manual-voucher-approval'
      fullPath: '/canteen/manual-voucher-approval'
      preLoaderRoute: typeof AuthCanteenManualVoucherApprovalRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/applications/manual-voucher-approval': {
      id: '/_auth/applications/manual-voucher-approval'
      path: '/applications/manual-voucher-approval'
      fullPath: '/applications/manual-voucher-approval'
      preLoaderRoute: typeof AuthApplicationsManualVoucherApprovalRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/settings': {
      id: '/_auth/administration/settings'
      path: '/administration/settings'
      fullPath: '/administration/settings'
      preLoaderRoute: typeof AuthAdministrationSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/monitoring': {
      id: '/_auth/administration/monitoring'
      path: '/administration/monitoring'
      fullPath: '/administration/monitoring'
      preLoaderRoute: typeof AuthAdministrationMonitoringRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_login/login/forgot-password/': {
      id: '/_login/login/forgot-password/'
      path: '/login/forgot-password'
      fullPath: '/login/forgot-password/'
      preLoaderRoute: typeof LoginLoginForgotPasswordIndexRouteImport
      parentRoute: typeof LoginRoute
    }
    '/_auth/canteen/menu-settings/': {
      id: '/_auth/canteen/menu-settings/'
      path: '/canteen/menu-settings'
      fullPath: '/canteen/menu-settings/'
      preLoaderRoute: typeof AuthCanteenMenuSettingsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/canteen/meal-restrictions/': {
      id: '/_auth/canteen/meal-restrictions/'
      path: '/'
      fullPath: '/canteen/meal-restrictions/'
      preLoaderRoute: typeof AuthCanteenMealRestrictionsIndexRouteImport
      parentRoute: typeof AuthCanteenMealRestrictionsRoute
    }
    '/_auth/applications/manual-voucher-approval/': {
      id: '/_auth/applications/manual-voucher-approval/'
      path: '/'
      fullPath: '/applications/manual-voucher-approval/'
      preLoaderRoute: typeof AuthApplicationsManualVoucherApprovalIndexRouteImport
      parentRoute: typeof AuthApplicationsManualVoucherApprovalRoute
    }
    '/_auth/applications/limitations/': {
      id: '/_auth/applications/limitations/'
      path: '/applications/limitations'
      fullPath: '/applications/limitations/'
      preLoaderRoute: typeof AuthApplicationsLimitationsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/reference-books/': {
      id: '/_auth/administration/reference-books/'
      path: '/administration/reference-books'
      fullPath: '/administration/reference-books/'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_login/login/forgot-password/verify-otp': {
      id: '/_login/login/forgot-password/verify-otp'
      path: '/login/forgot-password/verify-otp'
      fullPath: '/login/forgot-password/verify-otp'
      preLoaderRoute: typeof LoginLoginForgotPasswordVerifyOtpRouteImport
      parentRoute: typeof LoginRoute
    }
    '/_login/login/forgot-password/set-new-password': {
      id: '/_login/login/forgot-password/set-new-password'
      path: '/login/forgot-password/set-new-password'
      fullPath: '/login/forgot-password/set-new-password'
      preLoaderRoute: typeof LoginLoginForgotPasswordSetNewPasswordRouteImport
      parentRoute: typeof LoginRoute
    }
    '/_auth/users/update-role/$roleId': {
      id: '/_auth/users/update-role/$roleId'
      path: '/users/update-role/$roleId'
      fullPath: '/users/update-role/$roleId'
      preLoaderRoute: typeof AuthUsersUpdateRoleRoleIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/students/create': {
      id: '/_auth/users/students/create'
      path: '/create'
      fullPath: '/users/students/create'
      preLoaderRoute: typeof AuthUsersStudentsCreateRouteImport
      parentRoute: typeof AuthUsersStudentsRoute
    }
    '/_auth/users/students/$studentId': {
      id: '/_auth/users/students/$studentId'
      path: '/$studentId'
      fullPath: '/users/students/$studentId'
      preLoaderRoute: typeof AuthUsersStudentsStudentIdRouteImport
      parentRoute: typeof AuthUsersStudentsRoute
    }
    '/_auth/users/role/$roleId': {
      id: '/_auth/users/role/$roleId'
      path: '/users/role/$roleId'
      fullPath: '/users/role/$roleId'
      preLoaderRoute: typeof AuthUsersRoleRoleIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/parents/create': {
      id: '/_auth/users/parents/create'
      path: '/create'
      fullPath: '/users/parents/create'
      preLoaderRoute: typeof AuthUsersParentsCreateRouteImport
      parentRoute: typeof AuthUsersParentsRoute
    }
    '/_auth/users/parents/$parentId': {
      id: '/_auth/users/parents/$parentId'
      path: '/$parentId'
      fullPath: '/users/parents/$parentId'
      preLoaderRoute: typeof AuthUsersParentsParentIdRouteImport
      parentRoute: typeof AuthUsersParentsRoute
    }
    '/_auth/users/employees/create': {
      id: '/_auth/users/employees/create'
      path: '/create'
      fullPath: '/users/employees/create'
      preLoaderRoute: typeof AuthUsersEmployeesCreateRouteImport
      parentRoute: typeof AuthUsersEmployeesRoute
    }
    '/_auth/users/employees/$employeeId': {
      id: '/_auth/users/employees/$employeeId'
      path: '/$employeeId'
      fullPath: '/users/employees/$employeeId'
      preLoaderRoute: typeof AuthUsersEmployeesEmployeeIdRouteImport
      parentRoute: typeof AuthUsersEmployeesRoute
    }
    '/_auth/users/apk/roles': {
      id: '/_auth/users/apk/roles'
      path: '/roles'
      fullPath: '/users/apk/roles'
      preLoaderRoute: typeof AuthUsersApkRolesRouteImport
      parentRoute: typeof AuthUsersApkRoute
    }
    '/_auth/users/apk/list': {
      id: '/_auth/users/apk/list'
      path: '/list'
      fullPath: '/users/apk/list'
      preLoaderRoute: typeof AuthUsersApkListRouteImport
      parentRoute: typeof AuthUsersApkRoute
    }
    '/_auth/reports/vouchers/create': {
      id: '/_auth/reports/vouchers/create'
      path: '/create'
      fullPath: '/reports/vouchers/create'
      preLoaderRoute: typeof AuthReportsVouchersCreateRouteImport
      parentRoute: typeof AuthReportsVouchersRoute
    }
    '/_auth/reports/no-meal-vouchers/create': {
      id: '/_auth/reports/no-meal-vouchers/create'
      path: '/create'
      fullPath: '/reports/no-meal-vouchers/create'
      preLoaderRoute: typeof AuthReportsNoMealVouchersCreateRouteImport
      parentRoute: typeof AuthReportsNoMealVouchersRoute
    }
    '/_auth/reports/attendance/create': {
      id: '/_auth/reports/attendance/create'
      path: '/create'
      fullPath: '/reports/attendance/create'
      preLoaderRoute: typeof AuthReportsAttendanceCreateRouteImport
      parentRoute: typeof AuthReportsAttendanceRoute
    }
    '/_auth/journal/tabs/users': {
      id: '/_auth/journal/tabs/users'
      path: '/users'
      fullPath: '/journal/tabs/users'
      preLoaderRoute: typeof AuthJournalTabsUsersRouteImport
      parentRoute: typeof AuthJournalTabsRoute
    }
    '/_auth/journal/tabs/auth': {
      id: '/_auth/journal/tabs/auth'
      path: '/auth'
      fullPath: '/journal/tabs/auth'
      preLoaderRoute: typeof AuthJournalTabsAuthRouteImport
      parentRoute: typeof AuthJournalTabsRoute
    }
    '/_auth/canteen/menu-settings/dishes': {
      id: '/_auth/canteen/menu-settings/dishes'
      path: '/canteen/menu-settings/dishes'
      fullPath: '/canteen/menu-settings/dishes'
      preLoaderRoute: typeof AuthCanteenMenuSettingsDishesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/canteen/menu-settings/catalog-menu': {
      id: '/_auth/canteen/menu-settings/catalog-menu'
      path: '/canteen/menu-settings/catalog-menu'
      fullPath: '/canteen/menu-settings/catalog-menu'
      preLoaderRoute: typeof AuthCanteenMenuSettingsCatalogMenuRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/canteen/manual-attendance-and-food-receipt/list': {
      id: '/_auth/canteen/manual-attendance-and-food-receipt/list'
      path: '/canteen/manual-attendance-and-food-receipt/list'
      fullPath: '/canteen/manual-attendance-and-food-receipt/list'
      preLoaderRoute: typeof AuthCanteenManualAttendanceAndFoodReceiptListRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/applications/manual-voucher-confirmation/list': {
      id: '/_auth/applications/manual-voucher-confirmation/list'
      path: '/applications/manual-voucher-confirmation/list'
      fullPath: '/applications/manual-voucher-confirmation/list'
      preLoaderRoute: typeof AuthApplicationsManualVoucherConfirmationListRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/applications/manual-voucher-confirmation/$voucherId': {
      id: '/_auth/applications/manual-voucher-confirmation/$voucherId'
      path: '/applications/manual-voucher-confirmation/$voucherId'
      fullPath: '/applications/manual-voucher-confirmation/$voucherId'
      preLoaderRoute: typeof AuthApplicationsManualVoucherConfirmationVoucherIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/applications/manual-voucher-approval/$manualVoucherId': {
      id: '/_auth/applications/manual-voucher-approval/$manualVoucherId'
      path: '/$manualVoucherId'
      fullPath: '/applications/manual-voucher-approval/$manualVoucherId'
      preLoaderRoute: typeof AuthApplicationsManualVoucherApprovalManualVoucherIdRouteImport
      parentRoute: typeof AuthApplicationsManualVoucherApprovalRoute
    }
    '/_auth/applications/manual-requests/manual-requests': {
      id: '/_auth/applications/manual-requests/manual-requests'
      path: '/applications/manual-requests/manual-requests'
      fullPath: '/applications/manual-requests/manual-requests'
      preLoaderRoute: typeof AuthApplicationsManualRequestsManualRequestsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/settings/create': {
      id: '/_auth/administration/settings/create'
      path: '/create'
      fullPath: '/administration/settings/create'
      preLoaderRoute: typeof AuthAdministrationSettingsCreateRouteImport
      parentRoute: typeof AuthAdministrationSettingsRoute
    }
    '/_auth/administration/settings/$settingId': {
      id: '/_auth/administration/settings/$settingId'
      path: '/$settingId'
      fullPath: '/administration/settings/$settingId'
      preLoaderRoute: typeof AuthAdministrationSettingsSettingIdRouteImport
      parentRoute: typeof AuthAdministrationSettingsRoute
    }
    '/_auth/administration/reference-books/schools': {
      id: '/_auth/administration/reference-books/schools'
      path: '/administration/reference-books/schools'
      fullPath: '/administration/reference-books/schools'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksSchoolsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/reference-books/company': {
      id: '/_auth/administration/reference-books/company'
      path: '/administration/reference-books/company'
      fullPath: '/administration/reference-books/company'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCompanyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/reference-books/canteens': {
      id: '/_auth/administration/reference-books/canteens'
      path: '/administration/reference-books/canteens'
      fullPath: '/administration/reference-books/canteens'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCanteensRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/reference-books/cameras': {
      id: '/_auth/administration/reference-books/cameras'
      path: '/administration/reference-books/cameras'
      fullPath: '/administration/reference-books/cameras'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCamerasRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/monitoring/queue': {
      id: '/_auth/administration/monitoring/queue'
      path: '/queue'
      fullPath: '/administration/monitoring/queue'
      preLoaderRoute: typeof AuthAdministrationMonitoringQueueRouteImport
      parentRoute: typeof AuthAdministrationMonitoringRoute
    }
    '/_auth/administration/monitoring/processes': {
      id: '/_auth/administration/monitoring/processes'
      path: '/processes'
      fullPath: '/administration/monitoring/processes'
      preLoaderRoute: typeof AuthAdministrationMonitoringProcessesRouteImport
      parentRoute: typeof AuthAdministrationMonitoringRoute
    }
    '/_auth/canteen/menu-settings/catalog-menu/': {
      id: '/_auth/canteen/menu-settings/catalog-menu/'
      path: '/'
      fullPath: '/canteen/menu-settings/catalog-menu/'
      preLoaderRoute: typeof AuthCanteenMenuSettingsCatalogMenuIndexRouteImport
      parentRoute: typeof AuthCanteenMenuSettingsCatalogMenuRoute
    }
    '/_auth/users/students/update/$studentId': {
      id: '/_auth/users/students/update/$studentId'
      path: '/update/$studentId'
      fullPath: '/users/students/update/$studentId'
      preLoaderRoute: typeof AuthUsersStudentsUpdateStudentIdRouteImport
      parentRoute: typeof AuthUsersStudentsRoute
    }
    '/_auth/users/parents/update/$parentId': {
      id: '/_auth/users/parents/update/$parentId'
      path: '/update/$parentId'
      fullPath: '/users/parents/update/$parentId'
      preLoaderRoute: typeof AuthUsersParentsUpdateParentIdRouteImport
      parentRoute: typeof AuthUsersParentsRoute
    }
    '/_auth/users/employees/update/$employeeId': {
      id: '/_auth/users/employees/update/$employeeId'
      path: '/update/$employeeId'
      fullPath: '/users/employees/update/$employeeId'
      preLoaderRoute: typeof AuthUsersEmployeesUpdateEmployeeIdRouteImport
      parentRoute: typeof AuthUsersEmployeesRoute
    }
    '/_auth/users/apk/roles/$roleId': {
      id: '/_auth/users/apk/roles/$roleId'
      path: '/$roleId'
      fullPath: '/users/apk/roles/$roleId'
      preLoaderRoute: typeof AuthUsersApkRolesRoleIdRouteImport
      parentRoute: typeof AuthUsersApkRolesRoute
    }
    '/_auth/users/apk/list/create': {
      id: '/_auth/users/apk/list/create'
      path: '/create'
      fullPath: '/users/apk/list/create'
      preLoaderRoute: typeof AuthUsersApkListCreateRouteImport
      parentRoute: typeof AuthUsersApkListRoute
    }
    '/_auth/users/apk/list/$userId': {
      id: '/_auth/users/apk/list/$userId'
      path: '/$userId'
      fullPath: '/users/apk/list/$userId'
      preLoaderRoute: typeof AuthUsersApkListUserIdRouteImport
      parentRoute: typeof AuthUsersApkListRoute
    }
    '/_auth/reports/vouchers_/item/$reportId': {
      id: '/_auth/reports/vouchers_/item/$reportId'
      path: '/reports/vouchers/item/$reportId'
      fullPath: '/reports/vouchers/item/$reportId'
      preLoaderRoute: typeof AuthReportsVouchersItemReportIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/no-meal-vouchers_/item/$reportId': {
      id: '/_auth/reports/no-meal-vouchers_/item/$reportId'
      path: '/reports/no-meal-vouchers/item/$reportId'
      fullPath: '/reports/no-meal-vouchers/item/$reportId'
      preLoaderRoute: typeof AuthReportsNoMealVouchersItemReportIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/attendance_/item/$reportId': {
      id: '/_auth/reports/attendance_/item/$reportId'
      path: '/reports/attendance/item/$reportId'
      fullPath: '/reports/attendance/item/$reportId'
      preLoaderRoute: typeof AuthReportsAttendanceItemReportIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/canteen/user-comments/student/$studentId': {
      id: '/_auth/canteen/user-comments/student/$studentId'
      path: '/student/$studentId'
      fullPath: '/canteen/user-comments/student/$studentId'
      preLoaderRoute: typeof AuthCanteenUserCommentsStudentStudentIdRouteImport
      parentRoute: typeof AuthCanteenUserCommentsRoute
    }
    '/_auth/canteen/user-comments/dish/$dishId': {
      id: '/_auth/canteen/user-comments/dish/$dishId'
      path: '/dish/$dishId'
      fullPath: '/canteen/user-comments/dish/$dishId'
      preLoaderRoute: typeof AuthCanteenUserCommentsDishDishIdRouteImport
      parentRoute: typeof AuthCanteenUserCommentsRoute
    }
    '/_auth/canteen/user-comments/comment/$commentId': {
      id: '/_auth/canteen/user-comments/comment/$commentId'
      path: '/comment/$commentId'
      fullPath: '/canteen/user-comments/comment/$commentId'
      preLoaderRoute: typeof AuthCanteenUserCommentsCommentCommentIdRouteImport
      parentRoute: typeof AuthCanteenUserCommentsRoute
    }
    '/_auth/canteen/menu-settings/dishes/create': {
      id: '/_auth/canteen/menu-settings/dishes/create'
      path: '/create'
      fullPath: '/canteen/menu-settings/dishes/create'
      preLoaderRoute: typeof AuthCanteenMenuSettingsDishesCreateRouteImport
      parentRoute: typeof AuthCanteenMenuSettingsDishesRoute
    }
    '/_auth/canteen/menu-settings/dishes/$dishId': {
      id: '/_auth/canteen/menu-settings/dishes/$dishId'
      path: '/$dishId'
      fullPath: '/canteen/menu-settings/dishes/$dishId'
      preLoaderRoute: typeof AuthCanteenMenuSettingsDishesDishIdRouteImport
      parentRoute: typeof AuthCanteenMenuSettingsDishesRoute
    }
    '/_auth/canteen/menu-settings/catalog-menu/create': {
      id: '/_auth/canteen/menu-settings/catalog-menu/create'
      path: '/create'
      fullPath: '/canteen/menu-settings/catalog-menu/create'
      preLoaderRoute: typeof AuthCanteenMenuSettingsCatalogMenuCreateRouteImport
      parentRoute: typeof AuthCanteenMenuSettingsCatalogMenuRoute
    }
    '/_auth/canteen/meal-restrictions/restriction/$restrictionId': {
      id: '/_auth/canteen/meal-restrictions/restriction/$restrictionId'
      path: '/restriction/$restrictionId'
      fullPath: '/canteen/meal-restrictions/restriction/$restrictionId'
      preLoaderRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdRouteImport
      parentRoute: typeof AuthCanteenMealRestrictionsRoute
    }
    '/_auth/canteen/manual-attendance-and-food-receipt/item/create': {
      id: '/_auth/canteen/manual-attendance-and-food-receipt/item/create'
      path: '/canteen/manual-attendance-and-food-receipt/item/create'
      fullPath: '/canteen/manual-attendance-and-food-receipt/item/create'
      preLoaderRoute: typeof AuthCanteenManualAttendanceAndFoodReceiptItemCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/canteen/manual-attendance-and-food-receipt/item/$manualId': {
      id: '/_auth/canteen/manual-attendance-and-food-receipt/item/$manualId'
      path: '/canteen/manual-attendance-and-food-receipt/item/$manualId'
      fullPath: '/canteen/manual-attendance-and-food-receipt/item/$manualId'
      preLoaderRoute: typeof AuthCanteenManualAttendanceAndFoodReceiptItemManualIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/applications/manual-voucher-approval/$manualVoucherId/items': {
      id: '/_auth/applications/manual-voucher-approval/$manualVoucherId/items'
      path: '/items'
      fullPath: '/applications/manual-voucher-approval/$manualVoucherId/items'
      preLoaderRoute: typeof AuthApplicationsManualVoucherApprovalManualVoucherIdItemsRouteImport
      parentRoute: typeof AuthApplicationsManualVoucherApprovalManualVoucherIdRoute
    }
    '/_auth/applications/manual-voucher-approval/$manualVoucherId/history': {
      id: '/_auth/applications/manual-voucher-approval/$manualVoucherId/history'
      path: '/history'
      fullPath: '/applications/manual-voucher-approval/$manualVoucherId/history'
      preLoaderRoute: typeof AuthApplicationsManualVoucherApprovalManualVoucherIdHistoryRouteImport
      parentRoute: typeof AuthApplicationsManualVoucherApprovalManualVoucherIdRoute
    }
    '/_auth/applications/manual-voucher-approval/$manualVoucherId/common': {
      id: '/_auth/applications/manual-voucher-approval/$manualVoucherId/common'
      path: '/common'
      fullPath: '/applications/manual-voucher-approval/$manualVoucherId/common'
      preLoaderRoute: typeof AuthApplicationsManualVoucherApprovalManualVoucherIdCommonRouteImport
      parentRoute: typeof AuthApplicationsManualVoucherApprovalManualVoucherIdRoute
    }
    '/_auth/applications/manual-requests/manual-requests/create': {
      id: '/_auth/applications/manual-requests/manual-requests/create'
      path: '/create'
      fullPath: '/applications/manual-requests/manual-requests/create'
      preLoaderRoute: typeof AuthApplicationsManualRequestsManualRequestsCreateRouteImport
      parentRoute: typeof AuthApplicationsManualRequestsManualRequestsRoute
    }
    '/_auth/applications/manual-requests/manual-request/$requestId': {
      id: '/_auth/applications/manual-requests/manual-request/$requestId'
      path: '/applications/manual-requests/manual-request/$requestId'
      fullPath: '/applications/manual-requests/manual-request/$requestId'
      preLoaderRoute: typeof AuthApplicationsManualRequestsManualRequestRequestIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/applications/limitations/limitation/$limitationId': {
      id: '/_auth/applications/limitations/limitation/$limitationId'
      path: '/applications/limitations/limitation/$limitationId'
      fullPath: '/applications/limitations/limitation/$limitationId'
      preLoaderRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/settings/update/$settingId': {
      id: '/_auth/administration/settings/update/$settingId'
      path: '/update/$settingId'
      fullPath: '/administration/settings/update/$settingId'
      preLoaderRoute: typeof AuthAdministrationSettingsUpdateSettingIdRouteImport
      parentRoute: typeof AuthAdministrationSettingsRoute
    }
    '/_auth/administration/reference-books/schools/create': {
      id: '/_auth/administration/reference-books/schools/create'
      path: '/create'
      fullPath: '/administration/reference-books/schools/create'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksSchoolsCreateRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksSchoolsRoute
    }
    '/_auth/administration/reference-books/schools/$schoolId': {
      id: '/_auth/administration/reference-books/schools/$schoolId'
      path: '/$schoolId'
      fullPath: '/administration/reference-books/schools/$schoolId'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksSchoolsSchoolIdRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksSchoolsRoute
    }
    '/_auth/administration/reference-books/company/create': {
      id: '/_auth/administration/reference-books/company/create'
      path: '/create'
      fullPath: '/administration/reference-books/company/create'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCompanyCreateRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCompanyRoute
    }
    '/_auth/administration/reference-books/company/$companyId': {
      id: '/_auth/administration/reference-books/company/$companyId'
      path: '/$companyId'
      fullPath: '/administration/reference-books/company/$companyId'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCompanyCompanyIdRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCompanyRoute
    }
    '/_auth/administration/reference-books/canteens/list': {
      id: '/_auth/administration/reference-books/canteens/list'
      path: '/list'
      fullPath: '/administration/reference-books/canteens/list'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCanteensListRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCanteensRoute
    }
    '/_auth/administration/reference-books/canteens/connects': {
      id: '/_auth/administration/reference-books/canteens/connects'
      path: '/connects'
      fullPath: '/administration/reference-books/canteens/connects'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCanteensConnectsRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCanteensRoute
    }
    '/_auth/administration/reference-books/cameras/create': {
      id: '/_auth/administration/reference-books/cameras/create'
      path: '/create'
      fullPath: '/administration/reference-books/cameras/create'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCamerasCreateRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCamerasRoute
    }
    '/_auth/administration/reference-books/cameras/$cameraId': {
      id: '/_auth/administration/reference-books/cameras/$cameraId'
      path: '/$cameraId'
      fullPath: '/administration/reference-books/cameras/$cameraId'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCamerasCameraIdRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCamerasRoute
    }
    '/_auth/administration/monitoring/queue/$processId': {
      id: '/_auth/administration/monitoring/queue/$processId'
      path: '/$processId'
      fullPath: '/administration/monitoring/queue/$processId'
      preLoaderRoute: typeof AuthAdministrationMonitoringQueueProcessIdRouteImport
      parentRoute: typeof AuthAdministrationMonitoringQueueRoute
    }
    '/_auth/administration/monitoring/processes/$processId': {
      id: '/_auth/administration/monitoring/processes/$processId'
      path: '/$processId'
      fullPath: '/administration/monitoring/processes/$processId'
      preLoaderRoute: typeof AuthAdministrationMonitoringProcessesProcessIdRouteImport
      parentRoute: typeof AuthAdministrationMonitoringProcessesRoute
    }
    '/_auth/users/apk/roles/create/': {
      id: '/_auth/users/apk/roles/create/'
      path: '/create'
      fullPath: '/users/apk/roles/create/'
      preLoaderRoute: typeof AuthUsersApkRolesCreateIndexRouteImport
      parentRoute: typeof AuthUsersApkRolesRoute
    }
    '/_auth/users/apk/roles/update/$roleId': {
      id: '/_auth/users/apk/roles/update/$roleId'
      path: '/update/$roleId'
      fullPath: '/users/apk/roles/update/$roleId'
      preLoaderRoute: typeof AuthUsersApkRolesUpdateRoleIdRouteImport
      parentRoute: typeof AuthUsersApkRolesRoute
    }
    '/_auth/users/apk/list/update/$userId': {
      id: '/_auth/users/apk/list/update/$userId'
      path: '/update/$userId'
      fullPath: '/users/apk/list/update/$userId'
      preLoaderRoute: typeof AuthUsersApkListUpdateUserIdRouteImport
      parentRoute: typeof AuthUsersApkListRoute
    }
    '/_auth/canteen/menu-settings/dishes/update/$dishId': {
      id: '/_auth/canteen/menu-settings/dishes/update/$dishId'
      path: '/update/$dishId'
      fullPath: '/canteen/menu-settings/dishes/update/$dishId'
      preLoaderRoute: typeof AuthCanteenMenuSettingsDishesUpdateDishIdRouteImport
      parentRoute: typeof AuthCanteenMenuSettingsDishesRoute
    }
    '/_auth/canteen/menu-settings/catalog-menu/update/$menuId': {
      id: '/_auth/canteen/menu-settings/catalog-menu/update/$menuId'
      path: '/update/$menuId'
      fullPath: '/canteen/menu-settings/catalog-menu/update/$menuId'
      preLoaderRoute: typeof AuthCanteenMenuSettingsCatalogMenuUpdateMenuIdRouteImport
      parentRoute: typeof AuthCanteenMenuSettingsCatalogMenuRoute
    }
    '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId': {
      id: '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId'
      path: '/details/$menuCardId'
      fullPath: '/canteen/menu-settings/catalog-menu/details/$menuCardId'
      preLoaderRoute: typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRouteImport
      parentRoute: typeof AuthCanteenMenuSettingsCatalogMenuRoute
    }
    '/_auth/canteen/meal-restrictions/restriction/$restrictionId/common': {
      id: '/_auth/canteen/meal-restrictions/restriction/$restrictionId/common'
      path: '/common'
      fullPath: '/canteen/meal-restrictions/restriction/$restrictionId/common'
      preLoaderRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRouteImport
      parentRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdRoute
    }
    '/_auth/canteen/meal-restrictions/restriction/$restrictionId/allergens': {
      id: '/_auth/canteen/meal-restrictions/restriction/$restrictionId/allergens'
      path: '/allergens'
      fullPath: '/canteen/meal-restrictions/restriction/$restrictionId/allergens'
      preLoaderRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRouteImport
      parentRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdRoute
    }
    '/_auth/applications/manual-requests/manual-request/$requestId/history': {
      id: '/_auth/applications/manual-requests/manual-request/$requestId/history'
      path: '/history'
      fullPath: '/applications/manual-requests/manual-request/$requestId/history'
      preLoaderRoute: typeof AuthApplicationsManualRequestsManualRequestRequestIdHistoryRouteImport
      parentRoute: typeof AuthApplicationsManualRequestsManualRequestRequestIdRoute
    }
    '/_auth/applications/manual-requests/manual-request/$requestId/common': {
      id: '/_auth/applications/manual-requests/manual-request/$requestId/common'
      path: '/common'
      fullPath: '/applications/manual-requests/manual-request/$requestId/common'
      preLoaderRoute: typeof AuthApplicationsManualRequestsManualRequestRequestIdCommonRouteImport
      parentRoute: typeof AuthApplicationsManualRequestsManualRequestRequestIdRoute
    }
    '/_auth/applications/limitations/limitation/$limitationId/history': {
      id: '/_auth/applications/limitations/limitation/$limitationId/history'
      path: '/history'
      fullPath: '/applications/limitations/limitation/$limitationId/history'
      preLoaderRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdHistoryRouteImport
      parentRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdRoute
    }
    '/_auth/applications/limitations/limitation/$limitationId/common': {
      id: '/_auth/applications/limitations/limitation/$limitationId/common'
      path: '/common'
      fullPath: '/applications/limitations/limitation/$limitationId/common'
      preLoaderRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdCommonRouteImport
      parentRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdRoute
    }
    '/_auth/applications/limitations/limitation/$limitationId/allergens': {
      id: '/_auth/applications/limitations/limitation/$limitationId/allergens'
      path: '/allergens'
      fullPath: '/applications/limitations/limitation/$limitationId/allergens'
      preLoaderRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdAllergensRouteImport
      parentRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdRoute
    }
    '/_auth/administration/reference-books/schools/update/$schoolId': {
      id: '/_auth/administration/reference-books/schools/update/$schoolId'
      path: '/update/$schoolId'
      fullPath: '/administration/reference-books/schools/update/$schoolId'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksSchoolsUpdateSchoolIdRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksSchoolsRoute
    }
    '/_auth/administration/reference-books/company/update/$companyId': {
      id: '/_auth/administration/reference-books/company/update/$companyId'
      path: '/update/$companyId'
      fullPath: '/administration/reference-books/company/update/$companyId'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCompanyUpdateCompanyIdRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCompanyRoute
    }
    '/_auth/administration/reference-books/canteens/list/create': {
      id: '/_auth/administration/reference-books/canteens/list/create'
      path: '/create'
      fullPath: '/administration/reference-books/canteens/list/create'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCanteensListCreateRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCanteensListRoute
    }
    '/_auth/administration/reference-books/canteens/list/$canteenId': {
      id: '/_auth/administration/reference-books/canteens/list/$canteenId'
      path: '/$canteenId'
      fullPath: '/administration/reference-books/canteens/list/$canteenId'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCanteensListCanteenIdRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCanteensListRoute
    }
    '/_auth/administration/reference-books/canteens/connects/create': {
      id: '/_auth/administration/reference-books/canteens/connects/create'
      path: '/create'
      fullPath: '/administration/reference-books/canteens/connects/create'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCanteensConnectsCreateRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCanteensConnectsRoute
    }
    '/_auth/administration/reference-books/canteens/connects/$connectId': {
      id: '/_auth/administration/reference-books/canteens/connects/$connectId'
      path: '/$connectId'
      fullPath: '/administration/reference-books/canteens/connects/$connectId'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCanteensConnectsConnectIdRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCanteensConnectsRoute
    }
    '/_auth/administration/reference-books/cameras/update/$cameraId': {
      id: '/_auth/administration/reference-books/cameras/update/$cameraId'
      path: '/update/$cameraId'
      fullPath: '/administration/reference-books/cameras/update/$cameraId'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCamerasUpdateCameraIdRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCamerasRoute
    }
    '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId/parameters': {
      id: '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId/parameters'
      path: '/parameters'
      fullPath: '/canteen/menu-settings/catalog-menu/details/$menuCardId/parameters'
      preLoaderRoute: typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdParametersRouteImport
      parentRoute: typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRoute
    }
    '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId/common': {
      id: '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId/common'
      path: '/common'
      fullPath: '/canteen/menu-settings/catalog-menu/details/$menuCardId/common'
      preLoaderRoute: typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdCommonRouteImport
      parentRoute: typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRoute
    }
    '/_auth/administration/reference-books/canteens/list/update/$canteenId': {
      id: '/_auth/administration/reference-books/canteens/list/update/$canteenId'
      path: '/update/$canteenId'
      fullPath: '/administration/reference-books/canteens/list/update/$canteenId'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCanteensListUpdateCanteenIdRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCanteensListRoute
    }
    '/_auth/administration/reference-books/canteens/connects/update/$connectId': {
      id: '/_auth/administration/reference-books/canteens/connects/update/$connectId'
      path: '/update/$connectId'
      fullPath: '/administration/reference-books/canteens/connects/update/$connectId'
      preLoaderRoute: typeof AuthAdministrationReferenceBooksCanteensConnectsUpdateConnectIdRouteImport
      parentRoute: typeof AuthAdministrationReferenceBooksCanteensConnectsRoute
    }
    '/_auth/canteen/meal-restrictions/restriction/$restrictionId/common/user/$userId': {
      id: '/_auth/canteen/meal-restrictions/restriction/$restrictionId/common/user/$userId'
      path: '/user/$userId'
      fullPath: '/canteen/meal-restrictions/restriction/$restrictionId/common/user/$userId'
      preLoaderRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonUserUserIdRouteImport
      parentRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRoute
    }
    '/_auth/canteen/meal-restrictions/restriction/$restrictionId/allergens/dish/$dishId': {
      id: '/_auth/canteen/meal-restrictions/restriction/$restrictionId/allergens/dish/$dishId'
      path: '/dish/$dishId'
      fullPath: '/canteen/meal-restrictions/restriction/$restrictionId/allergens/dish/$dishId'
      preLoaderRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensDishDishIdRouteImport
      parentRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRoute
    }
    '/_auth/applications/limitations/limitation/$limitationId/common/user/$userId': {
      id: '/_auth/applications/limitations/limitation/$limitationId/common/user/$userId'
      path: '/user/$userId'
      fullPath: '/applications/limitations/limitation/$limitationId/common/user/$userId'
      preLoaderRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdCommonUserUserIdRouteImport
      parentRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdCommonRoute
    }
    '/_auth/applications/limitations/limitation/$limitationId/allergens/dish/$dishId': {
      id: '/_auth/applications/limitations/limitation/$limitationId/allergens/dish/$dishId'
      path: '/dish/$dishId'
      fullPath: '/applications/limitations/limitation/$limitationId/allergens/dish/$dishId'
      preLoaderRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdAllergensDishDishIdRouteImport
      parentRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdAllergensRoute
    }
  }
}

interface AuthAdministrationMonitoringProcessesRouteChildren {
  AuthAdministrationMonitoringProcessesProcessIdRoute: typeof AuthAdministrationMonitoringProcessesProcessIdRoute
}

const AuthAdministrationMonitoringProcessesRouteChildren: AuthAdministrationMonitoringProcessesRouteChildren =
  {
    AuthAdministrationMonitoringProcessesProcessIdRoute:
      AuthAdministrationMonitoringProcessesProcessIdRoute,
  }

const AuthAdministrationMonitoringProcessesRouteWithChildren =
  AuthAdministrationMonitoringProcessesRoute._addFileChildren(
    AuthAdministrationMonitoringProcessesRouteChildren,
  )

interface AuthAdministrationMonitoringQueueRouteChildren {
  AuthAdministrationMonitoringQueueProcessIdRoute: typeof AuthAdministrationMonitoringQueueProcessIdRoute
}

const AuthAdministrationMonitoringQueueRouteChildren: AuthAdministrationMonitoringQueueRouteChildren =
  {
    AuthAdministrationMonitoringQueueProcessIdRoute:
      AuthAdministrationMonitoringQueueProcessIdRoute,
  }

const AuthAdministrationMonitoringQueueRouteWithChildren =
  AuthAdministrationMonitoringQueueRoute._addFileChildren(
    AuthAdministrationMonitoringQueueRouteChildren,
  )

interface AuthAdministrationMonitoringRouteChildren {
  AuthAdministrationMonitoringProcessesRoute: typeof AuthAdministrationMonitoringProcessesRouteWithChildren
  AuthAdministrationMonitoringQueueRoute: typeof AuthAdministrationMonitoringQueueRouteWithChildren
}

const AuthAdministrationMonitoringRouteChildren: AuthAdministrationMonitoringRouteChildren =
  {
    AuthAdministrationMonitoringProcessesRoute:
      AuthAdministrationMonitoringProcessesRouteWithChildren,
    AuthAdministrationMonitoringQueueRoute:
      AuthAdministrationMonitoringQueueRouteWithChildren,
  }

const AuthAdministrationMonitoringRouteWithChildren =
  AuthAdministrationMonitoringRoute._addFileChildren(
    AuthAdministrationMonitoringRouteChildren,
  )

interface AuthAdministrationSettingsRouteChildren {
  AuthAdministrationSettingsSettingIdRoute: typeof AuthAdministrationSettingsSettingIdRoute
  AuthAdministrationSettingsCreateRoute: typeof AuthAdministrationSettingsCreateRoute
  AuthAdministrationSettingsUpdateSettingIdRoute: typeof AuthAdministrationSettingsUpdateSettingIdRoute
}

const AuthAdministrationSettingsRouteChildren: AuthAdministrationSettingsRouteChildren =
  {
    AuthAdministrationSettingsSettingIdRoute:
      AuthAdministrationSettingsSettingIdRoute,
    AuthAdministrationSettingsCreateRoute:
      AuthAdministrationSettingsCreateRoute,
    AuthAdministrationSettingsUpdateSettingIdRoute:
      AuthAdministrationSettingsUpdateSettingIdRoute,
  }

const AuthAdministrationSettingsRouteWithChildren =
  AuthAdministrationSettingsRoute._addFileChildren(
    AuthAdministrationSettingsRouteChildren,
  )

interface AuthApplicationsManualVoucherApprovalManualVoucherIdRouteChildren {
  AuthApplicationsManualVoucherApprovalManualVoucherIdCommonRoute: typeof AuthApplicationsManualVoucherApprovalManualVoucherIdCommonRoute
  AuthApplicationsManualVoucherApprovalManualVoucherIdHistoryRoute: typeof AuthApplicationsManualVoucherApprovalManualVoucherIdHistoryRoute
  AuthApplicationsManualVoucherApprovalManualVoucherIdItemsRoute: typeof AuthApplicationsManualVoucherApprovalManualVoucherIdItemsRoute
}

const AuthApplicationsManualVoucherApprovalManualVoucherIdRouteChildren: AuthApplicationsManualVoucherApprovalManualVoucherIdRouteChildren =
  {
    AuthApplicationsManualVoucherApprovalManualVoucherIdCommonRoute:
      AuthApplicationsManualVoucherApprovalManualVoucherIdCommonRoute,
    AuthApplicationsManualVoucherApprovalManualVoucherIdHistoryRoute:
      AuthApplicationsManualVoucherApprovalManualVoucherIdHistoryRoute,
    AuthApplicationsManualVoucherApprovalManualVoucherIdItemsRoute:
      AuthApplicationsManualVoucherApprovalManualVoucherIdItemsRoute,
  }

const AuthApplicationsManualVoucherApprovalManualVoucherIdRouteWithChildren =
  AuthApplicationsManualVoucherApprovalManualVoucherIdRoute._addFileChildren(
    AuthApplicationsManualVoucherApprovalManualVoucherIdRouteChildren,
  )

interface AuthApplicationsManualVoucherApprovalRouteChildren {
  AuthApplicationsManualVoucherApprovalManualVoucherIdRoute: typeof AuthApplicationsManualVoucherApprovalManualVoucherIdRouteWithChildren
  AuthApplicationsManualVoucherApprovalIndexRoute: typeof AuthApplicationsManualVoucherApprovalIndexRoute
}

const AuthApplicationsManualVoucherApprovalRouteChildren: AuthApplicationsManualVoucherApprovalRouteChildren =
  {
    AuthApplicationsManualVoucherApprovalManualVoucherIdRoute:
      AuthApplicationsManualVoucherApprovalManualVoucherIdRouteWithChildren,
    AuthApplicationsManualVoucherApprovalIndexRoute:
      AuthApplicationsManualVoucherApprovalIndexRoute,
  }

const AuthApplicationsManualVoucherApprovalRouteWithChildren =
  AuthApplicationsManualVoucherApprovalRoute._addFileChildren(
    AuthApplicationsManualVoucherApprovalRouteChildren,
  )

interface AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRouteChildren {
  AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensDishDishIdRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensDishDishIdRoute
}

const AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRouteChildren: AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRouteChildren =
  {
    AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensDishDishIdRoute:
      AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensDishDishIdRoute,
  }

const AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRouteWithChildren =
  AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRoute._addFileChildren(
    AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRouteChildren,
  )

interface AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRouteChildren {
  AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonUserUserIdRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonUserUserIdRoute
}

const AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRouteChildren: AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRouteChildren =
  {
    AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonUserUserIdRoute:
      AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonUserUserIdRoute,
  }

const AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRouteWithChildren =
  AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRoute._addFileChildren(
    AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRouteChildren,
  )

interface AuthCanteenMealRestrictionsRestrictionRestrictionIdRouteChildren {
  AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRouteWithChildren
  AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRouteWithChildren
}

const AuthCanteenMealRestrictionsRestrictionRestrictionIdRouteChildren: AuthCanteenMealRestrictionsRestrictionRestrictionIdRouteChildren =
  {
    AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRoute:
      AuthCanteenMealRestrictionsRestrictionRestrictionIdAllergensRouteWithChildren,
    AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRoute:
      AuthCanteenMealRestrictionsRestrictionRestrictionIdCommonRouteWithChildren,
  }

const AuthCanteenMealRestrictionsRestrictionRestrictionIdRouteWithChildren =
  AuthCanteenMealRestrictionsRestrictionRestrictionIdRoute._addFileChildren(
    AuthCanteenMealRestrictionsRestrictionRestrictionIdRouteChildren,
  )

interface AuthCanteenMealRestrictionsRouteChildren {
  AuthCanteenMealRestrictionsIndexRoute: typeof AuthCanteenMealRestrictionsIndexRoute
  AuthCanteenMealRestrictionsRestrictionRestrictionIdRoute: typeof AuthCanteenMealRestrictionsRestrictionRestrictionIdRouteWithChildren
}

const AuthCanteenMealRestrictionsRouteChildren: AuthCanteenMealRestrictionsRouteChildren =
  {
    AuthCanteenMealRestrictionsIndexRoute:
      AuthCanteenMealRestrictionsIndexRoute,
    AuthCanteenMealRestrictionsRestrictionRestrictionIdRoute:
      AuthCanteenMealRestrictionsRestrictionRestrictionIdRouteWithChildren,
  }

const AuthCanteenMealRestrictionsRouteWithChildren =
  AuthCanteenMealRestrictionsRoute._addFileChildren(
    AuthCanteenMealRestrictionsRouteChildren,
  )

interface AuthCanteenUserCommentsRouteChildren {
  AuthCanteenUserCommentsCommentCommentIdRoute: typeof AuthCanteenUserCommentsCommentCommentIdRoute
  AuthCanteenUserCommentsDishDishIdRoute: typeof AuthCanteenUserCommentsDishDishIdRoute
  AuthCanteenUserCommentsStudentStudentIdRoute: typeof AuthCanteenUserCommentsStudentStudentIdRoute
}

const AuthCanteenUserCommentsRouteChildren: AuthCanteenUserCommentsRouteChildren =
  {
    AuthCanteenUserCommentsCommentCommentIdRoute:
      AuthCanteenUserCommentsCommentCommentIdRoute,
    AuthCanteenUserCommentsDishDishIdRoute:
      AuthCanteenUserCommentsDishDishIdRoute,
    AuthCanteenUserCommentsStudentStudentIdRoute:
      AuthCanteenUserCommentsStudentStudentIdRoute,
  }

const AuthCanteenUserCommentsRouteWithChildren =
  AuthCanteenUserCommentsRoute._addFileChildren(
    AuthCanteenUserCommentsRouteChildren,
  )

interface AuthJournalTabsRouteChildren {
  AuthJournalTabsAuthRoute: typeof AuthJournalTabsAuthRoute
  AuthJournalTabsUsersRoute: typeof AuthJournalTabsUsersRoute
}

const AuthJournalTabsRouteChildren: AuthJournalTabsRouteChildren = {
  AuthJournalTabsAuthRoute: AuthJournalTabsAuthRoute,
  AuthJournalTabsUsersRoute: AuthJournalTabsUsersRoute,
}

const AuthJournalTabsRouteWithChildren = AuthJournalTabsRoute._addFileChildren(
  AuthJournalTabsRouteChildren,
)

interface AuthReportsAttendanceRouteChildren {
  AuthReportsAttendanceCreateRoute: typeof AuthReportsAttendanceCreateRoute
}

const AuthReportsAttendanceRouteChildren: AuthReportsAttendanceRouteChildren = {
  AuthReportsAttendanceCreateRoute: AuthReportsAttendanceCreateRoute,
}

const AuthReportsAttendanceRouteWithChildren =
  AuthReportsAttendanceRoute._addFileChildren(
    AuthReportsAttendanceRouteChildren,
  )

interface AuthReportsNoMealVouchersRouteChildren {
  AuthReportsNoMealVouchersCreateRoute: typeof AuthReportsNoMealVouchersCreateRoute
}

const AuthReportsNoMealVouchersRouteChildren: AuthReportsNoMealVouchersRouteChildren =
  {
    AuthReportsNoMealVouchersCreateRoute: AuthReportsNoMealVouchersCreateRoute,
  }

const AuthReportsNoMealVouchersRouteWithChildren =
  AuthReportsNoMealVouchersRoute._addFileChildren(
    AuthReportsNoMealVouchersRouteChildren,
  )

interface AuthReportsVouchersRouteChildren {
  AuthReportsVouchersCreateRoute: typeof AuthReportsVouchersCreateRoute
}

const AuthReportsVouchersRouteChildren: AuthReportsVouchersRouteChildren = {
  AuthReportsVouchersCreateRoute: AuthReportsVouchersCreateRoute,
}

const AuthReportsVouchersRouteWithChildren =
  AuthReportsVouchersRoute._addFileChildren(AuthReportsVouchersRouteChildren)

interface AuthUsersApkListRouteChildren {
  AuthUsersApkListUserIdRoute: typeof AuthUsersApkListUserIdRoute
  AuthUsersApkListCreateRoute: typeof AuthUsersApkListCreateRoute
  AuthUsersApkListUpdateUserIdRoute: typeof AuthUsersApkListUpdateUserIdRoute
}

const AuthUsersApkListRouteChildren: AuthUsersApkListRouteChildren = {
  AuthUsersApkListUserIdRoute: AuthUsersApkListUserIdRoute,
  AuthUsersApkListCreateRoute: AuthUsersApkListCreateRoute,
  AuthUsersApkListUpdateUserIdRoute: AuthUsersApkListUpdateUserIdRoute,
}

const AuthUsersApkListRouteWithChildren =
  AuthUsersApkListRoute._addFileChildren(AuthUsersApkListRouteChildren)

interface AuthUsersApkRolesRouteChildren {
  AuthUsersApkRolesRoleIdRoute: typeof AuthUsersApkRolesRoleIdRoute
  AuthUsersApkRolesUpdateRoleIdRoute: typeof AuthUsersApkRolesUpdateRoleIdRoute
  AuthUsersApkRolesCreateIndexRoute: typeof AuthUsersApkRolesCreateIndexRoute
}

const AuthUsersApkRolesRouteChildren: AuthUsersApkRolesRouteChildren = {
  AuthUsersApkRolesRoleIdRoute: AuthUsersApkRolesRoleIdRoute,
  AuthUsersApkRolesUpdateRoleIdRoute: AuthUsersApkRolesUpdateRoleIdRoute,
  AuthUsersApkRolesCreateIndexRoute: AuthUsersApkRolesCreateIndexRoute,
}

const AuthUsersApkRolesRouteWithChildren =
  AuthUsersApkRolesRoute._addFileChildren(AuthUsersApkRolesRouteChildren)

interface AuthUsersApkRouteChildren {
  AuthUsersApkListRoute: typeof AuthUsersApkListRouteWithChildren
  AuthUsersApkRolesRoute: typeof AuthUsersApkRolesRouteWithChildren
}

const AuthUsersApkRouteChildren: AuthUsersApkRouteChildren = {
  AuthUsersApkListRoute: AuthUsersApkListRouteWithChildren,
  AuthUsersApkRolesRoute: AuthUsersApkRolesRouteWithChildren,
}

const AuthUsersApkRouteWithChildren = AuthUsersApkRoute._addFileChildren(
  AuthUsersApkRouteChildren,
)

interface AuthUsersEmployeesRouteChildren {
  AuthUsersEmployeesEmployeeIdRoute: typeof AuthUsersEmployeesEmployeeIdRoute
  AuthUsersEmployeesCreateRoute: typeof AuthUsersEmployeesCreateRoute
  AuthUsersEmployeesUpdateEmployeeIdRoute: typeof AuthUsersEmployeesUpdateEmployeeIdRoute
}

const AuthUsersEmployeesRouteChildren: AuthUsersEmployeesRouteChildren = {
  AuthUsersEmployeesEmployeeIdRoute: AuthUsersEmployeesEmployeeIdRoute,
  AuthUsersEmployeesCreateRoute: AuthUsersEmployeesCreateRoute,
  AuthUsersEmployeesUpdateEmployeeIdRoute:
    AuthUsersEmployeesUpdateEmployeeIdRoute,
}

const AuthUsersEmployeesRouteWithChildren =
  AuthUsersEmployeesRoute._addFileChildren(AuthUsersEmployeesRouteChildren)

interface AuthUsersParentsRouteChildren {
  AuthUsersParentsParentIdRoute: typeof AuthUsersParentsParentIdRoute
  AuthUsersParentsCreateRoute: typeof AuthUsersParentsCreateRoute
  AuthUsersParentsUpdateParentIdRoute: typeof AuthUsersParentsUpdateParentIdRoute
}

const AuthUsersParentsRouteChildren: AuthUsersParentsRouteChildren = {
  AuthUsersParentsParentIdRoute: AuthUsersParentsParentIdRoute,
  AuthUsersParentsCreateRoute: AuthUsersParentsCreateRoute,
  AuthUsersParentsUpdateParentIdRoute: AuthUsersParentsUpdateParentIdRoute,
}

const AuthUsersParentsRouteWithChildren =
  AuthUsersParentsRoute._addFileChildren(AuthUsersParentsRouteChildren)

interface AuthUsersStudentsRouteChildren {
  AuthUsersStudentsStudentIdRoute: typeof AuthUsersStudentsStudentIdRoute
  AuthUsersStudentsCreateRoute: typeof AuthUsersStudentsCreateRoute
  AuthUsersStudentsUpdateStudentIdRoute: typeof AuthUsersStudentsUpdateStudentIdRoute
}

const AuthUsersStudentsRouteChildren: AuthUsersStudentsRouteChildren = {
  AuthUsersStudentsStudentIdRoute: AuthUsersStudentsStudentIdRoute,
  AuthUsersStudentsCreateRoute: AuthUsersStudentsCreateRoute,
  AuthUsersStudentsUpdateStudentIdRoute: AuthUsersStudentsUpdateStudentIdRoute,
}

const AuthUsersStudentsRouteWithChildren =
  AuthUsersStudentsRoute._addFileChildren(AuthUsersStudentsRouteChildren)

interface AuthAdministrationReferenceBooksCamerasRouteChildren {
  AuthAdministrationReferenceBooksCamerasCameraIdRoute: typeof AuthAdministrationReferenceBooksCamerasCameraIdRoute
  AuthAdministrationReferenceBooksCamerasCreateRoute: typeof AuthAdministrationReferenceBooksCamerasCreateRoute
  AuthAdministrationReferenceBooksCamerasUpdateCameraIdRoute: typeof AuthAdministrationReferenceBooksCamerasUpdateCameraIdRoute
}

const AuthAdministrationReferenceBooksCamerasRouteChildren: AuthAdministrationReferenceBooksCamerasRouteChildren =
  {
    AuthAdministrationReferenceBooksCamerasCameraIdRoute:
      AuthAdministrationReferenceBooksCamerasCameraIdRoute,
    AuthAdministrationReferenceBooksCamerasCreateRoute:
      AuthAdministrationReferenceBooksCamerasCreateRoute,
    AuthAdministrationReferenceBooksCamerasUpdateCameraIdRoute:
      AuthAdministrationReferenceBooksCamerasUpdateCameraIdRoute,
  }

const AuthAdministrationReferenceBooksCamerasRouteWithChildren =
  AuthAdministrationReferenceBooksCamerasRoute._addFileChildren(
    AuthAdministrationReferenceBooksCamerasRouteChildren,
  )

interface AuthAdministrationReferenceBooksCanteensConnectsRouteChildren {
  AuthAdministrationReferenceBooksCanteensConnectsConnectIdRoute: typeof AuthAdministrationReferenceBooksCanteensConnectsConnectIdRoute
  AuthAdministrationReferenceBooksCanteensConnectsCreateRoute: typeof AuthAdministrationReferenceBooksCanteensConnectsCreateRoute
  AuthAdministrationReferenceBooksCanteensConnectsUpdateConnectIdRoute: typeof AuthAdministrationReferenceBooksCanteensConnectsUpdateConnectIdRoute
}

const AuthAdministrationReferenceBooksCanteensConnectsRouteChildren: AuthAdministrationReferenceBooksCanteensConnectsRouteChildren =
  {
    AuthAdministrationReferenceBooksCanteensConnectsConnectIdRoute:
      AuthAdministrationReferenceBooksCanteensConnectsConnectIdRoute,
    AuthAdministrationReferenceBooksCanteensConnectsCreateRoute:
      AuthAdministrationReferenceBooksCanteensConnectsCreateRoute,
    AuthAdministrationReferenceBooksCanteensConnectsUpdateConnectIdRoute:
      AuthAdministrationReferenceBooksCanteensConnectsUpdateConnectIdRoute,
  }

const AuthAdministrationReferenceBooksCanteensConnectsRouteWithChildren =
  AuthAdministrationReferenceBooksCanteensConnectsRoute._addFileChildren(
    AuthAdministrationReferenceBooksCanteensConnectsRouteChildren,
  )

interface AuthAdministrationReferenceBooksCanteensListRouteChildren {
  AuthAdministrationReferenceBooksCanteensListCanteenIdRoute: typeof AuthAdministrationReferenceBooksCanteensListCanteenIdRoute
  AuthAdministrationReferenceBooksCanteensListCreateRoute: typeof AuthAdministrationReferenceBooksCanteensListCreateRoute
  AuthAdministrationReferenceBooksCanteensListUpdateCanteenIdRoute: typeof AuthAdministrationReferenceBooksCanteensListUpdateCanteenIdRoute
}

const AuthAdministrationReferenceBooksCanteensListRouteChildren: AuthAdministrationReferenceBooksCanteensListRouteChildren =
  {
    AuthAdministrationReferenceBooksCanteensListCanteenIdRoute:
      AuthAdministrationReferenceBooksCanteensListCanteenIdRoute,
    AuthAdministrationReferenceBooksCanteensListCreateRoute:
      AuthAdministrationReferenceBooksCanteensListCreateRoute,
    AuthAdministrationReferenceBooksCanteensListUpdateCanteenIdRoute:
      AuthAdministrationReferenceBooksCanteensListUpdateCanteenIdRoute,
  }

const AuthAdministrationReferenceBooksCanteensListRouteWithChildren =
  AuthAdministrationReferenceBooksCanteensListRoute._addFileChildren(
    AuthAdministrationReferenceBooksCanteensListRouteChildren,
  )

interface AuthAdministrationReferenceBooksCanteensRouteChildren {
  AuthAdministrationReferenceBooksCanteensConnectsRoute: typeof AuthAdministrationReferenceBooksCanteensConnectsRouteWithChildren
  AuthAdministrationReferenceBooksCanteensListRoute: typeof AuthAdministrationReferenceBooksCanteensListRouteWithChildren
}

const AuthAdministrationReferenceBooksCanteensRouteChildren: AuthAdministrationReferenceBooksCanteensRouteChildren =
  {
    AuthAdministrationReferenceBooksCanteensConnectsRoute:
      AuthAdministrationReferenceBooksCanteensConnectsRouteWithChildren,
    AuthAdministrationReferenceBooksCanteensListRoute:
      AuthAdministrationReferenceBooksCanteensListRouteWithChildren,
  }

const AuthAdministrationReferenceBooksCanteensRouteWithChildren =
  AuthAdministrationReferenceBooksCanteensRoute._addFileChildren(
    AuthAdministrationReferenceBooksCanteensRouteChildren,
  )

interface AuthAdministrationReferenceBooksCompanyRouteChildren {
  AuthAdministrationReferenceBooksCompanyCompanyIdRoute: typeof AuthAdministrationReferenceBooksCompanyCompanyIdRoute
  AuthAdministrationReferenceBooksCompanyCreateRoute: typeof AuthAdministrationReferenceBooksCompanyCreateRoute
  AuthAdministrationReferenceBooksCompanyUpdateCompanyIdRoute: typeof AuthAdministrationReferenceBooksCompanyUpdateCompanyIdRoute
}

const AuthAdministrationReferenceBooksCompanyRouteChildren: AuthAdministrationReferenceBooksCompanyRouteChildren =
  {
    AuthAdministrationReferenceBooksCompanyCompanyIdRoute:
      AuthAdministrationReferenceBooksCompanyCompanyIdRoute,
    AuthAdministrationReferenceBooksCompanyCreateRoute:
      AuthAdministrationReferenceBooksCompanyCreateRoute,
    AuthAdministrationReferenceBooksCompanyUpdateCompanyIdRoute:
      AuthAdministrationReferenceBooksCompanyUpdateCompanyIdRoute,
  }

const AuthAdministrationReferenceBooksCompanyRouteWithChildren =
  AuthAdministrationReferenceBooksCompanyRoute._addFileChildren(
    AuthAdministrationReferenceBooksCompanyRouteChildren,
  )

interface AuthAdministrationReferenceBooksSchoolsRouteChildren {
  AuthAdministrationReferenceBooksSchoolsSchoolIdRoute: typeof AuthAdministrationReferenceBooksSchoolsSchoolIdRoute
  AuthAdministrationReferenceBooksSchoolsCreateRoute: typeof AuthAdministrationReferenceBooksSchoolsCreateRoute
  AuthAdministrationReferenceBooksSchoolsUpdateSchoolIdRoute: typeof AuthAdministrationReferenceBooksSchoolsUpdateSchoolIdRoute
}

const AuthAdministrationReferenceBooksSchoolsRouteChildren: AuthAdministrationReferenceBooksSchoolsRouteChildren =
  {
    AuthAdministrationReferenceBooksSchoolsSchoolIdRoute:
      AuthAdministrationReferenceBooksSchoolsSchoolIdRoute,
    AuthAdministrationReferenceBooksSchoolsCreateRoute:
      AuthAdministrationReferenceBooksSchoolsCreateRoute,
    AuthAdministrationReferenceBooksSchoolsUpdateSchoolIdRoute:
      AuthAdministrationReferenceBooksSchoolsUpdateSchoolIdRoute,
  }

const AuthAdministrationReferenceBooksSchoolsRouteWithChildren =
  AuthAdministrationReferenceBooksSchoolsRoute._addFileChildren(
    AuthAdministrationReferenceBooksSchoolsRouteChildren,
  )

interface AuthApplicationsManualRequestsManualRequestsRouteChildren {
  AuthApplicationsManualRequestsManualRequestsCreateRoute: typeof AuthApplicationsManualRequestsManualRequestsCreateRoute
}

const AuthApplicationsManualRequestsManualRequestsRouteChildren: AuthApplicationsManualRequestsManualRequestsRouteChildren =
  {
    AuthApplicationsManualRequestsManualRequestsCreateRoute:
      AuthApplicationsManualRequestsManualRequestsCreateRoute,
  }

const AuthApplicationsManualRequestsManualRequestsRouteWithChildren =
  AuthApplicationsManualRequestsManualRequestsRoute._addFileChildren(
    AuthApplicationsManualRequestsManualRequestsRouteChildren,
  )

interface AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRouteChildren {
  AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdCommonRoute: typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdCommonRoute
  AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdParametersRoute: typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdParametersRoute
}

const AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRouteChildren: AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRouteChildren =
  {
    AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdCommonRoute:
      AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdCommonRoute,
    AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdParametersRoute:
      AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdParametersRoute,
  }

const AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRouteWithChildren =
  AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRoute._addFileChildren(
    AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRouteChildren,
  )

interface AuthCanteenMenuSettingsCatalogMenuRouteChildren {
  AuthCanteenMenuSettingsCatalogMenuCreateRoute: typeof AuthCanteenMenuSettingsCatalogMenuCreateRoute
  AuthCanteenMenuSettingsCatalogMenuIndexRoute: typeof AuthCanteenMenuSettingsCatalogMenuIndexRoute
  AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRoute: typeof AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRouteWithChildren
  AuthCanteenMenuSettingsCatalogMenuUpdateMenuIdRoute: typeof AuthCanteenMenuSettingsCatalogMenuUpdateMenuIdRoute
}

const AuthCanteenMenuSettingsCatalogMenuRouteChildren: AuthCanteenMenuSettingsCatalogMenuRouteChildren =
  {
    AuthCanteenMenuSettingsCatalogMenuCreateRoute:
      AuthCanteenMenuSettingsCatalogMenuCreateRoute,
    AuthCanteenMenuSettingsCatalogMenuIndexRoute:
      AuthCanteenMenuSettingsCatalogMenuIndexRoute,
    AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRoute:
      AuthCanteenMenuSettingsCatalogMenuDetailsMenuCardIdRouteWithChildren,
    AuthCanteenMenuSettingsCatalogMenuUpdateMenuIdRoute:
      AuthCanteenMenuSettingsCatalogMenuUpdateMenuIdRoute,
  }

const AuthCanteenMenuSettingsCatalogMenuRouteWithChildren =
  AuthCanteenMenuSettingsCatalogMenuRoute._addFileChildren(
    AuthCanteenMenuSettingsCatalogMenuRouteChildren,
  )

interface AuthCanteenMenuSettingsDishesRouteChildren {
  AuthCanteenMenuSettingsDishesDishIdRoute: typeof AuthCanteenMenuSettingsDishesDishIdRoute
  AuthCanteenMenuSettingsDishesCreateRoute: typeof AuthCanteenMenuSettingsDishesCreateRoute
  AuthCanteenMenuSettingsDishesUpdateDishIdRoute: typeof AuthCanteenMenuSettingsDishesUpdateDishIdRoute
}

const AuthCanteenMenuSettingsDishesRouteChildren: AuthCanteenMenuSettingsDishesRouteChildren =
  {
    AuthCanteenMenuSettingsDishesDishIdRoute:
      AuthCanteenMenuSettingsDishesDishIdRoute,
    AuthCanteenMenuSettingsDishesCreateRoute:
      AuthCanteenMenuSettingsDishesCreateRoute,
    AuthCanteenMenuSettingsDishesUpdateDishIdRoute:
      AuthCanteenMenuSettingsDishesUpdateDishIdRoute,
  }

const AuthCanteenMenuSettingsDishesRouteWithChildren =
  AuthCanteenMenuSettingsDishesRoute._addFileChildren(
    AuthCanteenMenuSettingsDishesRouteChildren,
  )

interface AuthApplicationsLimitationsLimitationLimitationIdAllergensRouteChildren {
  AuthApplicationsLimitationsLimitationLimitationIdAllergensDishDishIdRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdAllergensDishDishIdRoute
}

const AuthApplicationsLimitationsLimitationLimitationIdAllergensRouteChildren: AuthApplicationsLimitationsLimitationLimitationIdAllergensRouteChildren =
  {
    AuthApplicationsLimitationsLimitationLimitationIdAllergensDishDishIdRoute:
      AuthApplicationsLimitationsLimitationLimitationIdAllergensDishDishIdRoute,
  }

const AuthApplicationsLimitationsLimitationLimitationIdAllergensRouteWithChildren =
  AuthApplicationsLimitationsLimitationLimitationIdAllergensRoute._addFileChildren(
    AuthApplicationsLimitationsLimitationLimitationIdAllergensRouteChildren,
  )

interface AuthApplicationsLimitationsLimitationLimitationIdCommonRouteChildren {
  AuthApplicationsLimitationsLimitationLimitationIdCommonUserUserIdRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdCommonUserUserIdRoute
}

const AuthApplicationsLimitationsLimitationLimitationIdCommonRouteChildren: AuthApplicationsLimitationsLimitationLimitationIdCommonRouteChildren =
  {
    AuthApplicationsLimitationsLimitationLimitationIdCommonUserUserIdRoute:
      AuthApplicationsLimitationsLimitationLimitationIdCommonUserUserIdRoute,
  }

const AuthApplicationsLimitationsLimitationLimitationIdCommonRouteWithChildren =
  AuthApplicationsLimitationsLimitationLimitationIdCommonRoute._addFileChildren(
    AuthApplicationsLimitationsLimitationLimitationIdCommonRouteChildren,
  )

interface AuthApplicationsLimitationsLimitationLimitationIdRouteChildren {
  AuthApplicationsLimitationsLimitationLimitationIdAllergensRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdAllergensRouteWithChildren
  AuthApplicationsLimitationsLimitationLimitationIdCommonRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdCommonRouteWithChildren
  AuthApplicationsLimitationsLimitationLimitationIdHistoryRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdHistoryRoute
}

const AuthApplicationsLimitationsLimitationLimitationIdRouteChildren: AuthApplicationsLimitationsLimitationLimitationIdRouteChildren =
  {
    AuthApplicationsLimitationsLimitationLimitationIdAllergensRoute:
      AuthApplicationsLimitationsLimitationLimitationIdAllergensRouteWithChildren,
    AuthApplicationsLimitationsLimitationLimitationIdCommonRoute:
      AuthApplicationsLimitationsLimitationLimitationIdCommonRouteWithChildren,
    AuthApplicationsLimitationsLimitationLimitationIdHistoryRoute:
      AuthApplicationsLimitationsLimitationLimitationIdHistoryRoute,
  }

const AuthApplicationsLimitationsLimitationLimitationIdRouteWithChildren =
  AuthApplicationsLimitationsLimitationLimitationIdRoute._addFileChildren(
    AuthApplicationsLimitationsLimitationLimitationIdRouteChildren,
  )

interface AuthApplicationsManualRequestsManualRequestRequestIdRouteChildren {
  AuthApplicationsManualRequestsManualRequestRequestIdCommonRoute: typeof AuthApplicationsManualRequestsManualRequestRequestIdCommonRoute
  AuthApplicationsManualRequestsManualRequestRequestIdHistoryRoute: typeof AuthApplicationsManualRequestsManualRequestRequestIdHistoryRoute
}

const AuthApplicationsManualRequestsManualRequestRequestIdRouteChildren: AuthApplicationsManualRequestsManualRequestRequestIdRouteChildren =
  {
    AuthApplicationsManualRequestsManualRequestRequestIdCommonRoute:
      AuthApplicationsManualRequestsManualRequestRequestIdCommonRoute,
    AuthApplicationsManualRequestsManualRequestRequestIdHistoryRoute:
      AuthApplicationsManualRequestsManualRequestRequestIdHistoryRoute,
  }

const AuthApplicationsManualRequestsManualRequestRequestIdRouteWithChildren =
  AuthApplicationsManualRequestsManualRequestRequestIdRoute._addFileChildren(
    AuthApplicationsManualRequestsManualRequestRequestIdRouteChildren,
  )

interface AuthRouteChildren {
  AuthPhotoRulesRoute: typeof AuthPhotoRulesRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAdministrationMonitoringRoute: typeof AuthAdministrationMonitoringRouteWithChildren
  AuthAdministrationSettingsRoute: typeof AuthAdministrationSettingsRouteWithChildren
  AuthApplicationsManualVoucherApprovalRoute: typeof AuthApplicationsManualVoucherApprovalRouteWithChildren
  AuthCanteenManualVoucherApprovalRoute: typeof AuthCanteenManualVoucherApprovalRoute
  AuthCanteenMealRestrictionsRoute: typeof AuthCanteenMealRestrictionsRouteWithChildren
  AuthCanteenUserCommentsRoute: typeof AuthCanteenUserCommentsRouteWithChildren
  AuthJournalTabsRoute: typeof AuthJournalTabsRouteWithChildren
  AuthReportsAttendanceRoute: typeof AuthReportsAttendanceRouteWithChildren
  AuthReportsDashboardsRoute: typeof AuthReportsDashboardsRoute
  AuthReportsNoMealVouchersRoute: typeof AuthReportsNoMealVouchersRouteWithChildren
  AuthReportsVouchersRoute: typeof AuthReportsVouchersRouteWithChildren
  AuthUsersApkRoute: typeof AuthUsersApkRouteWithChildren
  AuthUsersCreateRoleRoute: typeof AuthUsersCreateRoleRoute
  AuthUsersEmployeesRoute: typeof AuthUsersEmployeesRouteWithChildren
  AuthUsersParentsRoute: typeof AuthUsersParentsRouteWithChildren
  AuthUsersStudentsRoute: typeof AuthUsersStudentsRouteWithChildren
  AuthAdministrationIndexRoute: typeof AuthAdministrationIndexRoute
  AuthApplicationsIndexRoute: typeof AuthApplicationsIndexRoute
  AuthCanteenIndexRoute: typeof AuthCanteenIndexRoute
  AuthJournalIndexRoute: typeof AuthJournalIndexRoute
  AuthReportsIndexRoute: typeof AuthReportsIndexRoute
  AuthUsersIndexRoute: typeof AuthUsersIndexRoute
  AuthAdministrationReferenceBooksCamerasRoute: typeof AuthAdministrationReferenceBooksCamerasRouteWithChildren
  AuthAdministrationReferenceBooksCanteensRoute: typeof AuthAdministrationReferenceBooksCanteensRouteWithChildren
  AuthAdministrationReferenceBooksCompanyRoute: typeof AuthAdministrationReferenceBooksCompanyRouteWithChildren
  AuthAdministrationReferenceBooksSchoolsRoute: typeof AuthAdministrationReferenceBooksSchoolsRouteWithChildren
  AuthApplicationsManualRequestsManualRequestsRoute: typeof AuthApplicationsManualRequestsManualRequestsRouteWithChildren
  AuthApplicationsManualVoucherConfirmationVoucherIdRoute: typeof AuthApplicationsManualVoucherConfirmationVoucherIdRoute
  AuthApplicationsManualVoucherConfirmationListRoute: typeof AuthApplicationsManualVoucherConfirmationListRoute
  AuthCanteenManualAttendanceAndFoodReceiptListRoute: typeof AuthCanteenManualAttendanceAndFoodReceiptListRoute
  AuthCanteenMenuSettingsCatalogMenuRoute: typeof AuthCanteenMenuSettingsCatalogMenuRouteWithChildren
  AuthCanteenMenuSettingsDishesRoute: typeof AuthCanteenMenuSettingsDishesRouteWithChildren
  AuthUsersRoleRoleIdRoute: typeof AuthUsersRoleRoleIdRoute
  AuthUsersUpdateRoleRoleIdRoute: typeof AuthUsersUpdateRoleRoleIdRoute
  AuthAdministrationReferenceBooksIndexRoute: typeof AuthAdministrationReferenceBooksIndexRoute
  AuthApplicationsLimitationsIndexRoute: typeof AuthApplicationsLimitationsIndexRoute
  AuthCanteenMenuSettingsIndexRoute: typeof AuthCanteenMenuSettingsIndexRoute
  AuthApplicationsLimitationsLimitationLimitationIdRoute: typeof AuthApplicationsLimitationsLimitationLimitationIdRouteWithChildren
  AuthApplicationsManualRequestsManualRequestRequestIdRoute: typeof AuthApplicationsManualRequestsManualRequestRequestIdRouteWithChildren
  AuthCanteenManualAttendanceAndFoodReceiptItemManualIdRoute: typeof AuthCanteenManualAttendanceAndFoodReceiptItemManualIdRoute
  AuthCanteenManualAttendanceAndFoodReceiptItemCreateRoute: typeof AuthCanteenManualAttendanceAndFoodReceiptItemCreateRoute
  AuthReportsAttendanceItemReportIdRoute: typeof AuthReportsAttendanceItemReportIdRoute
  AuthReportsNoMealVouchersItemReportIdRoute: typeof AuthReportsNoMealVouchersItemReportIdRoute
  AuthReportsVouchersItemReportIdRoute: typeof AuthReportsVouchersItemReportIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthPhotoRulesRoute: AuthPhotoRulesRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAdministrationMonitoringRoute:
    AuthAdministrationMonitoringRouteWithChildren,
  AuthAdministrationSettingsRoute: AuthAdministrationSettingsRouteWithChildren,
  AuthApplicationsManualVoucherApprovalRoute:
    AuthApplicationsManualVoucherApprovalRouteWithChildren,
  AuthCanteenManualVoucherApprovalRoute: AuthCanteenManualVoucherApprovalRoute,
  AuthCanteenMealRestrictionsRoute:
    AuthCanteenMealRestrictionsRouteWithChildren,
  AuthCanteenUserCommentsRoute: AuthCanteenUserCommentsRouteWithChildren,
  AuthJournalTabsRoute: AuthJournalTabsRouteWithChildren,
  AuthReportsAttendanceRoute: AuthReportsAttendanceRouteWithChildren,
  AuthReportsDashboardsRoute: AuthReportsDashboardsRoute,
  AuthReportsNoMealVouchersRoute: AuthReportsNoMealVouchersRouteWithChildren,
  AuthReportsVouchersRoute: AuthReportsVouchersRouteWithChildren,
  AuthUsersApkRoute: AuthUsersApkRouteWithChildren,
  AuthUsersCreateRoleRoute: AuthUsersCreateRoleRoute,
  AuthUsersEmployeesRoute: AuthUsersEmployeesRouteWithChildren,
  AuthUsersParentsRoute: AuthUsersParentsRouteWithChildren,
  AuthUsersStudentsRoute: AuthUsersStudentsRouteWithChildren,
  AuthAdministrationIndexRoute: AuthAdministrationIndexRoute,
  AuthApplicationsIndexRoute: AuthApplicationsIndexRoute,
  AuthCanteenIndexRoute: AuthCanteenIndexRoute,
  AuthJournalIndexRoute: AuthJournalIndexRoute,
  AuthReportsIndexRoute: AuthReportsIndexRoute,
  AuthUsersIndexRoute: AuthUsersIndexRoute,
  AuthAdministrationReferenceBooksCamerasRoute:
    AuthAdministrationReferenceBooksCamerasRouteWithChildren,
  AuthAdministrationReferenceBooksCanteensRoute:
    AuthAdministrationReferenceBooksCanteensRouteWithChildren,
  AuthAdministrationReferenceBooksCompanyRoute:
    AuthAdministrationReferenceBooksCompanyRouteWithChildren,
  AuthAdministrationReferenceBooksSchoolsRoute:
    AuthAdministrationReferenceBooksSchoolsRouteWithChildren,
  AuthApplicationsManualRequestsManualRequestsRoute:
    AuthApplicationsManualRequestsManualRequestsRouteWithChildren,
  AuthApplicationsManualVoucherConfirmationVoucherIdRoute:
    AuthApplicationsManualVoucherConfirmationVoucherIdRoute,
  AuthApplicationsManualVoucherConfirmationListRoute:
    AuthApplicationsManualVoucherConfirmationListRoute,
  AuthCanteenManualAttendanceAndFoodReceiptListRoute:
    AuthCanteenManualAttendanceAndFoodReceiptListRoute,
  AuthCanteenMenuSettingsCatalogMenuRoute:
    AuthCanteenMenuSettingsCatalogMenuRouteWithChildren,
  AuthCanteenMenuSettingsDishesRoute:
    AuthCanteenMenuSettingsDishesRouteWithChildren,
  AuthUsersRoleRoleIdRoute: AuthUsersRoleRoleIdRoute,
  AuthUsersUpdateRoleRoleIdRoute: AuthUsersUpdateRoleRoleIdRoute,
  AuthAdministrationReferenceBooksIndexRoute:
    AuthAdministrationReferenceBooksIndexRoute,
  AuthApplicationsLimitationsIndexRoute: AuthApplicationsLimitationsIndexRoute,
  AuthCanteenMenuSettingsIndexRoute: AuthCanteenMenuSettingsIndexRoute,
  AuthApplicationsLimitationsLimitationLimitationIdRoute:
    AuthApplicationsLimitationsLimitationLimitationIdRouteWithChildren,
  AuthApplicationsManualRequestsManualRequestRequestIdRoute:
    AuthApplicationsManualRequestsManualRequestRequestIdRouteWithChildren,
  AuthCanteenManualAttendanceAndFoodReceiptItemManualIdRoute:
    AuthCanteenManualAttendanceAndFoodReceiptItemManualIdRoute,
  AuthCanteenManualAttendanceAndFoodReceiptItemCreateRoute:
    AuthCanteenManualAttendanceAndFoodReceiptItemCreateRoute,
  AuthReportsAttendanceItemReportIdRoute:
    AuthReportsAttendanceItemReportIdRoute,
  AuthReportsNoMealVouchersItemReportIdRoute:
    AuthReportsNoMealVouchersItemReportIdRoute,
  AuthReportsVouchersItemReportIdRoute: AuthReportsVouchersItemReportIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DashboardRouteChildren {
  DashboardDashboardRoute: typeof DashboardDashboardRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardDashboardRoute: DashboardDashboardRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface LoginRouteChildren {
  LoginAuthSetPasswordRoute: typeof LoginAuthSetPasswordRoute
  LoginLoginIndexRoute: typeof LoginLoginIndexRoute
  LoginLoginForgotPasswordSetNewPasswordRoute: typeof LoginLoginForgotPasswordSetNewPasswordRoute
  LoginLoginForgotPasswordVerifyOtpRoute: typeof LoginLoginForgotPasswordVerifyOtpRoute
  LoginLoginForgotPasswordIndexRoute: typeof LoginLoginForgotPasswordIndexRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginAuthSetPasswordRoute: LoginAuthSetPasswordRoute,
  LoginLoginIndexRoute: LoginLoginIndexRoute,
  LoginLoginForgotPasswordSetNewPasswordRoute:
    LoginLoginForgotPasswordSetNewPasswordRoute,
  LoginLoginForgotPasswordVerifyOtpRoute:
    LoginLoginForgotPasswordVerifyOtpRoute,
  LoginLoginForgotPasswordIndexRoute: LoginLoginForgotPasswordIndexRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
  LoginRoute: LoginRouteWithChildren,
  CanteenDashboardRoute: CanteenDashboardRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
